<template>
  <b-container>
    <Breadcrumbs crumbString="Create and Estimate"></Breadcrumbs>
    <b-row>
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>
          <p>To create an estimated cost for your project, simply complete the steps to the right, add your contact information, and click “Submit.” You will receive your estimate via email.<br><br>
            If you don't see what you have in mind, or if you have questions, please give us a call or send us an email.</p>
        </div>
        <div class="contact-info">
          <span><strong>enviroSIGNS</strong></span>
          <span>2370 E Stringham Ave.</span>
          <span>Salt Lake City, UT 84109</span>
          <br>
          <span>North Canton, Ohio Office</span>
          <span><a href="mailto:tina@envirosigns.com">tina@envirosigns.com</a></span>
          <br>
          <span>(888) 492-5377</span>
          <span>(801) 942-5812</span>
          <span>(801) 943-6008 fax</span>
          <span><a href="mailto:info@envirosigns.com">info@envirosigns.com</a></span>
        </div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8 flip-mobile">
        <b-container>
          <div style="margin-bottom: 15px;">
            <b-form ref="preform" v-if="preformShow">
              <div>
                <h4><strong>Create an Estimate</strong></h4>
                <p>Please provide your email address to create an estimate.</p>
                <b-form-group class="form-required" label="Email:" label-for="preform-email" description="We'll never share your email with anyone else.">
                  <b-form-input id="preform-email" class="inputs" v-model="preform.preformEmail" name="email" type="email" required placeholder="Email address"></b-form-input>
                </b-form-group>
                <b-form-group class="form-required" label="How did you hear about us?" label-for="preform-how">
                  <b-form-select id="preform-how" class="inputs" v-model="preform.preformHow" name="howDidYouHear" :options="howDidYouHear" required></b-form-select>
                </b-form-group>
                <b-form-group v-if="preform.preformHow === 'Other'" class="form-required" label-for="preform-other">
                  <b-form-input id="preform-other" class="inputs" v-model="preform.preformOther" name="other" type="text" required></b-form-input>
                </b-form-group>
                <b-form-group>
                  <div id="recaptcha1" class="g-recaptcha" data-sitekey="6LcDp34dAAAAABF2DTi3_1p-fjXkEA2S2uZUS_-g"></div>
                </b-form-group>
                <b-button @click.prevent="processPreForm" class="form-submit" :disabled="!preform.preformEmail">Submit</b-button>
              </div>
            </b-form>
            <div v-if="chooseForm">
              <p v-if="thankYouMessage">Thank you. Now create an estimate.</p>
              <div style="display: flex; flex-direction: column; align-items: flex-start;">
                <b-btn class="m-1" @click="formGraphicShow = true; chooseForm = false;">Full-color Graphic Panels</b-btn>
                <b-btn class="m-1" @click="formNovalloyShow = true; chooseForm = false;">Metal Panels and Plaques</b-btn>
                <div><b-btn class="m-1" disabled>Routed HDPE Panels</b-btn> (coming soon)</div>
                <!-- <b-btn class="m-1" @click="formAmenitiesShow = true; chooseForm = false;">Recycled Plastic Site Amenities and Bulletin Cases</b-btn> -->
                <b-btn class="m-1" @click="formStorywalkShow = true; chooseForm = false;">Storywalk Frames and Posts</b-btn>
              </div>
            </div>
            <b-form ref="formGraphic" v-show="formGraphicShow || formAmenitiesShow || formNovalloyShow || formStorywalkShow" :action="`${uri}/static/xero/authorization.php`" method="POST" id="estimate-form">
              <div>
                <b-btn @click="resetForm">Choose a different type</b-btn><br><br>
                <p v-if="formAmenitiesShow">We continue to do our best to offset material costs and labor issues. However, we are seeing cost increases that we hope to be temporary.
                  Effective with all orders placed June 1, 2022, a 10% surcharge will be applied to some items.
                  It will be noted as a line item on your final quotes.
                  We understand no one likes to hear of increases but also understand our 10% surcharge is well below those imposed by our competitors.
                  We appreciate your understanding and continued support and will do our best to continue to enable your business.</p>
                <p>NOTE: Additional combinations of mountings and panels are available. Additional mounting, graphic panel,
                  and design options and sizes are also available. If you don't see what you have in mind, or if you have questions,
                  please give us a call or send us an email.</p>
              </div>
              <!-- step 1 contact info -->
              <div class="contact">
                <hr>
                <h4><strong>Step 1: Enter Contact Info</strong></h4>
                <b-form-group class="form-required" label="Your Company:" label-for="form-company">
                  <b-form-input id="form-company" class="inputs" v-model="form.company" name="company" type="text" required placeholder="Company name"></b-form-input>
                </b-form-group>
                <b-form-group class="form-required" id="input-group-2" label="Your Name:" label-for="form-first">
                  <b-row>
                    <b-col class="col-sm-6 col-md-12 contact-form-last-name">
                      <b-form-input id="form-first" class="inputs" v-model="form.first" name="first" required placeholder="First name"></b-form-input>
                    </b-col>
                    <b-col class="col-sm-6 col-md-12">
                      <b-form-input id="form-last" class="inputs" v-model="form.last" name="last" required placeholder="Last name"></b-form-input>
                    </b-col>
                  </b-row>
                </b-form-group>
                <b-form-group class="form-required" label="Email:" label-for="form-email" description="We'll never share your email with anyone else.">
                  <b-form-input id="form-email" class="inputs" v-model="form.email" name="email" type="email" required placeholder="Email address"></b-form-input>
                </b-form-group>
                <b-form-group class="form-required" label="Address:" label-for="form-address">
                  <b-form-input id="form-address" class="inputs" v-model="form.address" name="address" type="text" required placeholder="Address"></b-form-input>
                </b-form-group>
                <b-form-group class="form-required" label="City:" label-for="form-city">
                  <b-form-input id="form-city" class="inputs" v-model="form.city" name="city" type="text" required placeholder="City"></b-form-input>
                </b-form-group>
                <b-form-group class="form-required" label="State:" label-for="form-state">
                  <b-form-input id="form-state" class="inputs" v-model="form.state" name="state" type="text" required placeholder="State"></b-form-input>
                </b-form-group>
                <b-form-group class="form-required" label="Postal:" label-for="form-postal">
                  <b-form-input id="form-postal" class="inputs" v-model="form.postal" name="postal" type="text" required placeholder="Postal Code"></b-form-input>
                </b-form-group>
                <div style="display: flex;">
                  <b-form-group class="form-required" label="Area Code:" label-for="form-area">
                    <b-form-input style="max-width: 55px; margin-right: 15px;" id="form-area" class="inputs" maxlength="3" v-model="form.area" name="area" type="tel" pattern="\d*" title="Only numbers allowed" required placeholder="# # #"></b-form-input>
                  </b-form-group>
                  <b-form-group class="form-required" label="Phone Number:" label-for="form-phone">
                    <b-form-input id="form-phone" class="inputs" maxlength="7" v-model="form.phone" name="phone" type="tel" pattern="\d*" title="Only numbers allowed" required placeholder="# # # # # # #"></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <!-- amenities -->
              <div v-if="formAmenitiesShow">
                <h4><strong>Step 2: Select a Category</strong></h4>
                <div style="display: flex;">
                  <b-form-group class="form-required" style="flex-grow: 1;">
                    <b-form-select @input="updateAmenityCategory" :options="amenityCategories" :value="form.amenityCategory" required></b-form-select>
                  </b-form-group>
                </div>
                <h4><strong>Step 3: Select a Type</strong></h4>
                <div style="display: flex;">
                  <b-form-group class="form-required" style="flex-grow: 1;">
                    <b-form-select @input="updateAmenityType" :disabled="!form.amenityCategory" :options="amenityTypes" :value="form.amenityType" required></b-form-select>
                  </b-form-group>
                </div>
                <div>
                  <h4><strong>Step 3: Select an Item and Quantity</strong></h4>
                  <p v-show="amenityImages.length">Hover over the images to see the product name.</p>
                  <div style="display: flex; flex-wrap: wrap;">
                    <img v-for="image of amenityImages" :key="image.img" :alt="image.title" :title="image.title" :src="require(`../../assets/images/amenities/${image.img}.jpg`)" class="display-image" />
                  </div>
                  <div style="display: flex;">
                    <b-form-group class="form-required" style="flex-grow: 1;">
                      <b-form-select name="amenityOption" @input="updateAmenityOptions" :disabled="!form.amenityCategory || !form.amenityType" :options="amenityOptions" :value="form.amenityOption" required></b-form-select>
                    </b-form-group>
                    <span style="margin: 0 10px; padding-top: 6px;">Qty:</span><b-form-input style="max-width: 55px;" maxlength="3" min="1" max="999" @blur="validateQty" :disabled="!form.amenityCategory" v-model.number="form.amenityQty" name="amenityQty" type="number" pattern="\d*" title="Only numbers allowed" required placeholder="#"></b-form-input>
                  </div>
                  <div v-if="form.amenityOption" style="text-align: center; display: flex; justify-content: center;">
                    <img :src="require(`../../assets/images/amenities/${amenityImg}.jpg`)" height="300px" style="min-width: 0;" />
                    <div style="padding: 10px;">
                      <img src="../../assets/images/amenities/colors.png" width="200px" />
                      <p>Please indicate your choice of color option in the notes.</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- novalloy step 2 and 3 -->
              <div v-if="formNovalloyShow">
                <h4><strong>Step 2: Select Graphic Panel</strong></h4>
                <p>Hover over one of the images to see the graphic panel styles. Then select a graphic panel style and size from the drop-down below the thumbnails.</p>
                <div>
                  <div style="display: flex; flex-wrap: wrap;">
                    <img src="../../assets/images/thumbs/13.jpg" @mouseenter="showThumb(13)" @mouseleave="hideThumb" class="display-image" alt="Two-color, no Halftone Images" title="Two-color, no Halftone Images"/>
                    <img src="../../assets/images/thumbs/14.jpg" @mouseenter="showThumb(14)" @mouseleave="hideThumb" class="display-image" alt="Two-color with Halftone Images" title="Two-color with Halftone Images"/>
                    <img src="../../assets/images/thumbs/15.jpg" @mouseenter="showThumb(15)" @mouseleave="hideThumb" class="display-image" alt="Three-color with Halftone Images" title="Three-color with Halftone Images"/>
                  </div>
                  <img v-if="thumb.show" :src="require(`../../assets/images/thumbs/${thumb.num}.jpg`)" width="500">
                </div>
                <div style="display: flex; margin-top: 5px;">
                  <b-form-group class="form-required" style="flex-grow: 1;">
                    <b-form-select @input="updateNovalloyGraphic" name="novalloyGraphic" :value="form.novalloyGraphic" :options="novalloyGraphics" required></b-form-select>
                  </b-form-group>
                  <span style="margin: 0 10px; padding-top: 6px;">Qty:</span><b-form-input style="max-width: 55px;" maxlength="3" min="1" max="999" @blur="validateQty" v-model.number="form.novalloyGraphicQty" name="novalloyGraphicQty" type="number" pattern="\d*" title="Only numbers allowed" required placeholder="#"></b-form-input>
                </div>
                <hr>
                <h4><strong>Step 3: Select Mounting Style</strong></h4>
                <div style="display: flex;">
                  <b-form-group class="form-required" style="flex-grow: 1;">
                    <b-form-select @input="updateNovalloyMounting" name="novalloyMounting" :disabled="!form.novalloyGraphic" :value="form.novalloyMounting" :options="novalloyMountingOptions" required></b-form-select>
                  </b-form-group>
                  <span style="margin: 0 10px; padding-top: 6px;">Qty:</span><b-form-input style="max-width: 55px;" maxlength="3" min="1" max="999" @blur="validateQty" :disabled="!form.novalloyGraphic || novalloyMountingQtyDisabled" v-model.number="form.novalloyMountingQty" name="novalloyMountingQty" type="number" pattern="\d*" title="Only numbers allowed" required placeholder="#"></b-form-input>
                </div>
              </div>
              <div v-if="formStorywalkShow">
                <h4><strong>Step 2: Select Storywalk Post Type</strong></h4>
                <p>Hover over one of the images to see the frames and posts. Then select a post and quantity between 16 and 24 from the drop-down below the thumbnails.</p>
                <div>
                  <div style="display: flex; flex-wrap: wrap;">
                    <img src="../../assets/images/thumbs/16.jpg" @mouseenter="showThumb(16)" @mouseleave="hideThumb" class="display-image" alt="Angled Aluminum Post Mount" title="Angled Aluminum Post Mount"/>
                    <img src="../../assets/images/thumbs/17.jpg" @mouseenter="showThumb(17)" @mouseleave="hideThumb" class="display-image" alt="Flush Aluminum Post Mount" title="Flush Aluminum Post Mount"/>
                    <img src="../../assets/images/thumbs/18.jpg" @mouseenter="showThumb(18)" @mouseleave="hideThumb" class="display-image" alt="Angled Wood Post Mount" title="Angled Wood Post Mount"/>
                    <img src="../../assets/images/thumbs/19.jpg" @mouseenter="showThumb(19)" @mouseleave="hideThumb" class="display-image" alt="Flush Wood Post Mount" title="Flush Wood Post Mount"/>
                  </div>
                  <img v-if="thumb.show" :src="require(`../../assets/images/thumbs/${thumb.num}.jpg`)" width="500">
                </div>
                <div style="display: flex; margin-top: 5px;">
                  <b-form-group class="form-required" style="flex-grow: 1;">
                    <b-form-select @input="updateStorywalkPost" name="storywalkPost" :value="form.storywalkPost" :options="storywalkPosts" required></b-form-select>
                  </b-form-group>
                  <span style="margin: 0 10px; padding-top: 6px;">Qty:</span><b-form-input style="max-width: 55px;" maxlength="2" min="16" max="24" @blur="validateQty" v-model.number="form.storywalkPostQty" name="storywalkPostQty" type="number" pattern="\d*" title="Quantity must be between 16 and 24" required placeholder="#"></b-form-input>
                </div>
                <hr>
                <h4><strong>Step 3: Select Backer Sheets</strong></h4>
                <p>Make creating your Storywalk layouts easier with Storywalk Backer Sheets.
                  This thin, durable plastic allows you to tape your Storywalk images in place indoors, before installing in your frames.
                  Cut to size and thin enough to be sandwich between your two sheets of Storywalk Frame acrylic.
                  Consider getting an extra set so your frames are never left empty!
                </p>
                <div style="display: flex; margin-top: 5px;">
                  <b-form-group class="form-required" style="flex-grow: 1;" description="Choose 1 or 2 sets.">
                    <b-form-select @input="updateStorywalkBackers" name="storywalkBackers" :disabled="!form.storywalkPost" :value="form.storywalkBackers" :options="storywalkBackers" required></b-form-select>
                  </b-form-group>
                  <span style="margin: 0 10px; padding-top: 6px;">Qty:</span><b-form-input style="max-width: 55px;" maxlength="1" min="1" max="2" @blur="validateBackerQty" :disabled="!form.storywalkPost || !form.storywalkBackers || JSON.parse(form.storywalkBackers).code === 'none'" v-model.number="form.storywalkBackersQty" name="storywalkBackersQty" type="number" pattern="\d*" title="Quantity is either 1x or 2x posts" required></b-form-input>
                </div>
                <div style="margin-top: 5px;" v-show="form.storywalkBackers && JSON.parse(form.storywalkBackers).code !== 'none'">
                  <div>
                    <b-form-group class="form-required" style="flex-grow: 1;" description="Color can be adjusted for the final order.">
                      <b-form-select @input="updateStorywalkColors" name="storywalkColors" :disabled="!form.storywalkPost || !form.storywalkBackers || JSON.parse(form.storywalkBackers).code === 'none'" :value="form.storywalkColors" :options="storywalkColors" :required="form.storywalkBackers && JSON.parse(form.storywalkBackers).code !== 'none'"></b-form-select>
                    </b-form-group>
                  </div>
                  <div style="text-align: center">
                    <img :src="require('@/assets/images/pages/story-walk/backer-colors.png')" width="80%">
                  </div>
                </div>
                <hr>
              </div>
              <!-- step 1 mounting -->
              <div v-if="formGraphicShow">
                <h4><strong>Step 2: Select Mounting Style</strong></h4>
                <p>If a mounting angle other than 45 degrees or a powder coat color other than black is desired, please indicate this in the notes section in Step 6.</p>
                <p>Hover over one of the images to see the mounting style. Then select a mounting style and size from the drop-down below the thumbnails</p>
                <div>
                  <div style="display: flex; flex-wrap: wrap;">
                    <img src="../../assets/images/thumbs/1.jpg" @mouseenter="showThumb(1)" @mouseleave="hideThumb" class="display-image" alt="Cantilever Base with Frame" title="Cantilever Base with Frame"/>
                    <img src="../../assets/images/thumbs/2.jpg" @mouseenter="showThumb(2)" @mouseleave="hideThumb" class="display-image" alt="Cantilever Pedestals" title="Cantilever Pedestals"/>
                    <img src="../../assets/images/thumbs/3.jpg" @mouseenter="showThumb(3)" @mouseleave="hideThumb" class="display-image" alt="Double Pedestal Posts" title="Double Pedestal Posts"/>
                    <img src="../../assets/images/thumbs/4.jpg" @mouseenter="showThumb(4)" @mouseleave="hideThumb" class="display-image" alt="Double Pedestal with Frame" title="Double Pedestal with Frame"/>
                    <img src="../../assets/images/thumbs/5.jpg" @mouseenter="showThumb(5)" @mouseleave="hideThumb" class="display-image" alt="Mounting Plate with Wood Post Mount Sleeve (front)" title="Mounting Plate with Wood Post Mount Sleeve (front)"/>
                    <img src="../../assets/images/thumbs/6.jpg" @mouseenter="showThumb(6)" @mouseleave="hideThumb" class="display-image" alt="Mounting Plate with Wood Post Mount Sleeve (back)" title="Mounting Plate with Wood Post Mount Sleeve (back)"/>
                    <img src="../../assets/images/thumbs/7.jpg" @mouseenter="showThumb(7)" @mouseleave="hideThumb" class="display-image" alt="Single Pedestal Post" title="Single Pedestal Post"/>
                    <img src="../../assets/images/thumbs/8.jpg" @mouseenter="showThumb(8)" @mouseleave="hideThumb" class="display-image" alt="Single Pedestal with Frame" title="Single Pedestal with Frame"/>
                    <img src="../../assets/images/thumbs/9.jpg" @mouseenter="showThumb(9)" @mouseleave="hideThumb" class="display-image" alt="Traditional Base with Frame" title="Traditional Base with Frame"/>
                    <img src="../../assets/images/thumbs/10.jpg" @mouseenter="showThumb(10)" @mouseleave="hideThumb" class="display-image" alt="Upright Base with Frame" title="Upright Base with Frame"/>
                    <img src="../../assets/images/thumbs/11.jpg" @mouseenter="showThumb(11)" @mouseleave="hideThumb" class="display-image" alt="Upright Pedestals" title="Upright Pedestals"/>
                    <img src="../../assets/images/thumbs/12.jpg" @mouseenter="showThumb(12)" @mouseleave="hideThumb" class="display-image" alt="Wall Mount with Frame" title="Wall Mount with Frame"/>
                  </div>
                  <img v-if="thumb.show" :src="require(`../../assets/images/thumbs/${thumb.num}.jpg`)" width="500">
                </div>
                <div style="display: flex; margin-top: 5px;">
                  <b-form-group class="form-required" style="flex-grow: 1;">
                    <b-form-select @input="updateMountingStyle" name="mountingStyle" :value="form.mountingStyle" :options="mountingStyleOptions" required></b-form-select>
                  </b-form-group>
                  <span style="margin: 0 10px; padding-top: 6px;">Qty:</span><b-form-input :disabled="mountingStyleQtyDisabled" style="max-width: 55px;" maxlength="3" min="1" max="999" @blur="validateQty" v-model.number="form.mountingStyleQty" name="mountingStyleQty" type="number" pattern="\d*" title="Only numbers allowed" required placeholder="#"></b-form-input>
                </div>
              </div>
              <!-- step 3 graphic panel -->
              <div v-if="formGraphicShow">
                <hr>
                <h4><strong>Step 3: Select Graphic Panel</strong></h4>
                <div style="display: flex;">
                  <b-form-group class="form-required" style="flex-grow: 1;">
                    <b-form-select @input="updateGraphicPanel" name="graphicPanel" :disabled="!form.mountingStyle" :value="form.graphicPanel" :options="form.mountingStyle ? selectedTree.graphicPanelOptions : [{ value: null, text: 'Please select a mounting style' }]" required></b-form-select>
                  </b-form-group>
                  <span style="margin: 0 10px; padding-top: 6px;">Qty:</span><b-form-input style="max-width: 55px;" maxlength="3" min="1" max="999" @blur="validateQty" :disabled="!form.mountingStyle || graphicPanelQtyDisabled" v-model.number="form.graphicPanelQty" name="graphicPanelQty" type="number" pattern="\d*" title="Only numbers allowed" required placeholder="#"></b-form-input>
                </div>
                <div v-if="showMandatoryMessage">
                  DuraReader panels require an additional, one-time, $100.00 production setup. This cost will automatically be added to your final estimate.
                  <input type="hidden" name="productionSetup" :value="productionSetupValue">
                </div>
              </div>
              <!-- step 3 design proofing -->
              <div v-if="formGraphicShow || formNovalloyShow">
                <div v-if="!noGraphicPanel">
                  <hr>
                  <h4><strong>Step 4: Select Design and Proofing Options</strong></h4>
                  <div style="display: flex;">
                    <b-radio v-model="designOption" :disabled="artworkDisabled" name="design" value="ready" class="mr-3">I have my artwork ready</b-radio>
                    <b-radio v-model="designOption" :disabled="artworkDisabled" name="design" value="help">I need help with my artwork</b-radio>
                  </div>
                  <hr>
                  <div style="display: flex; flex-direction: column;" v-if="(designOption && form.graphicPanel && form.mountingStyle) || (designOption && form.novalloyGraphic && form.novalloyMounting)">
                    <b-form-checkbox v-if="designOption === 'help'" v-model="form.layoutDesign" name="layoutDesign" value='{ "code": "9000", "price": "400.00", "description": "Layout Design" }'>Layout Design - $400.00<span v-if="form.graphicPanelQty > 1"> (x{{ form.graphicPanelQty }})</span><span v-if="form.novalloyGraphicQty > 1"> (x{{ form.novalloyGraphicQty }})</span></b-form-checkbox>
                    <b-form-checkbox v-if="designOption === 'help'" v-model="form.illustration" name="illustration" value='{ "code": "9005", "price": "800.00", "description": "Illustration" }'>Illustration - $800.00<span v-if="form.graphicPanelQty > 1"> (x{{ form.graphicPanelQty }})</span><span v-if="form.novalloyGraphicQty > 1"> (x{{ form.novalloyGraphicQty }})</span></b-form-checkbox>
                    <b-form-checkbox v-if="designOption === 'help'" v-model="form.textWriting" name="textWriting" value='{ "code": "9006", "price": "600.00", "description": "Text Writing" }'>Text Writing - $600.00<span v-if="form.graphicPanelQty > 1"> (x{{ form.graphicPanelQty }})</span><span v-if="form.novalloyGraphicQty > 1"> (x{{ form.novalloyGraphicQty }})</span></b-form-checkbox>
                    <b-form-checkbox v-if="designOption" v-model="form.layoutProof" name="layoutProof" value='{ "code": "9004", "price": "0.00", "description": "Layout Proof" }'>Layout Proof - $0.00</b-form-checkbox>
                    <b-form-checkbox v-if="designOption && formGraphicShow" v-model="form.colorSample" name="colorSample" value='{ "code": "9003", "price": "75.00", "description": "Color Sample" }'>Color Sample - $75.00</b-form-checkbox>
                  </div>
                  <div v-if="(designOption === 'ready' && form.graphicPanel && form.mountingStyle) || (designOption === 'ready' && form.novalloyGraphic && form.novalloyMounting)" style="margin-top: 10px;">
                    A one-time, $75.00 client file setup will automatically be added to your final estimate.
                    <input type="hidden" name="clientSetup" :value="clientSetupValue"></div>
                  <hr v-if="(designOption && form.graphicPanel && form.mountingStyle) || (designOption && form.novalloyGraphic && form.novalloyMounting)">
                </div>
                <div v-else>
                  <hr>
                </div>
              </div>
              <div v-if="formStorywalkShow">
                <h4><strong>Step 4: Shipping</strong></h4>
                <div>
                  <p>To receive a shipping quote, please indicate the following in the notes section at the bottom of this page.</p>
                  <ul>
                    <li>Business Name</li>
                    <li>Contact Name</li>
                    <li>Address</li>
                    <li>Phone Number</li>
                    <li>If the location is a business or residence</li>
                    <li>If a delivery appointment is required</li>
                    <li>If a loading dock or forklift is available for offloading</li>
                  </ul>
                </div>
              </div>
              <div v-else class="shipping">
                <h4><strong>Step <span v-if="noGraphicPanel">4</span><span v-else>5</span>: Shipping Cost</strong></h4>
                <div>Shipping is estimated at 18% of the fabrication costs. No special services, such as a liftgate or delivery appointment, are included. Firm shipping quotes can be provided upon request or at the time your order is placed.</div>
                <div style="min-height: 28px" v-html="shippingCost">
                </div>
                <input type="hidden" name="shipping" :value="shipping">
                <div>Estimate Subtotal: <span style="font-size: larger; font-weight: bold; margin-left: 10px;">{{ subtotal }}</span></div>
              </div>
              <div>
                <hr>
                <h4><strong>Step <span v-if="formStorywalkShow">5</span><span v-else>6</span>: Add Notes</strong></h4>
                <b-form-group label="Additional Notes:" label-for="form-note">
                  <b-form-textarea id="form-note" class="inputs" v-model="form.note" maxlength="2500" name="summary" placeholder="Notes about your order" rows="3" max-rows="6"></b-form-textarea>
                </b-form-group>
              </div>
              <b-form-group class="form-required">
                <div id="recaptcha2" class="g-recaptcha" data-sitekey="6Ld9vH4dAAAAAKwVFogbHfWjbZkNzDJerbg6432Z"></div>
              </b-form-group>
              <b-button @click="processGraphicForm" class="form-submit" :disabled="!fullForm">Submit</b-button>
            </b-form>
            <div v-if="message !== ''" id="form-response" class="form-message">
              <hr class="submit-hr"> {{ this.message }}
              <br><br>
              <div v-if="message === 'An error occurred. Please try again.'"><b-btn @click="resetForm">Create another estimate</b-btn></div>
            </div>
            <div v-if="showDownload" style="display: flex; flex-direction: column; text-align: center;">
              <div style="margin-bottom: 5px;"><a :href="downloadLink" target="_blank" @click="downloadClicked">Download estimate PDF</a></div>
              <div><b-btn @click="resetForm">Create another estimate</b-btn></div>
            </div>
          </div>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '../Breadcrumbs.vue'
  import axios from 'axios'

  export default {
    components: {
      Breadcrumbs
    },
    data () {
      return {
        downloadLink: '',
        showDownload: false,
        thankYouMessage: true,
        designOption: '',
        thumb: {
          show: false,
          num: 1
        },
        selectedTree: null,
        shipping: null,
        title: 'Create an Estimate',
        preformShow: true,
        chooseForm: false,
        formAmenitiesShow: false,
        formGraphicShow: false,
        formNovalloyShow: false,
        formStorywalkShow: false,
        preform: {
          preformEmail: '',
          preformHow: null,
          preformOther: null
        },
        form: {
          company: '',
          first: '',
          last: '',
          email: '',
          address: '',
          city: '',
          state: '',
          postal: '',
          area: '',
          phone: '',
          amenityCategory: null,
          amenityType: null,
          amenityOption: null,
          amenityQty: 1,
          novalloyGraphic: null,
          novalloyGraphicQty: 1,
          novalloyMounting: null,
          novalloyMountingQty: 1,
          novalloyMountingQtyDisabled: false,
          mountingStyle: null,
          mountingStyleQty: 1,
          storywalkPost: null,
          storywalkPostQty: 16,
          storywalkBackers: null,
          storywalkBackersQty: 0,
          storywalkColors: null,
          graphicPanel: null,
          graphicPanelQty: 1,
          colorSample: null,
          layoutProof: null,
          textWriting: null,
          illustration: null,
          layoutDesign: null,
          note: ''
        },
        amenityImages: [],
        amenityCategories: [
          { value: null, text: 'Please select an option' },
          { value: 'benches', text: 'Benches' },
          { value: 'tables', text: 'Tables' },
          { value: 'receptacles', text: 'Receptacles' },
          { value: 'facilities', text: 'Bulletin Cases' }
        ],
        amenityBenches: [
          { value: null, text: 'Please select an option' },
          {
            label: '4\' Backed Benches',
            options: [
              { value: '{ "code": "B4-SL", "description": "Snow Leopard 4\' Backed Bench", "price": "377", "img": "benches/snow-leopard-4" }', text: 'Snow Leopard 4\' Backed Bench - $377' },
              { value: '{ "code": "B4-L", "description": "Lynx 4\' Backed Bench", "price": "351", "img": "benches/lynx-4" }', text: 'Lynx 4\' Backed Bench - $351' },
              { value: '{ "code": "B4-W", "description": "Whale 4\' Backed Bench", "price": "524", "img": "benches/whale-4" }', text: 'Whale 4\' Backed Bench - $524' },
              { value: '{ "code": "B4-T", "description": "Tiger 4\' Backed Bench", "price": "317", "img": "benches/tiger-4" }', text: 'Tiger 4\' Backed Bench - $317' },
              { value: '{ "code": "B4-R", "description": "Rhinoceros 4\' Backed Bench", "price": "338", "img": "benches/rhino-4" }', text: 'Rhinoceros 4\' Backed Bench - $338' },
              { value: '{ "code": "B4-LN", "description": "Lion 4\' Backed Bench", "price": "373", "img": "benches/lion-4" }', text: 'Lion 4\' Backed Bench - $373' },
              { value: '{ "code": "B4-C", "description": "Cheetah 4\' Backed Bench", "price": "394", "img": "benches/cheetah-4" }', text: 'Cheetah 4\' Backed Bench - $394' },
              { value: '{ "code": "B4-P", "description": "Panda 4\' Backed Bench", "price": "398", "img": "benches/panda-4" }', text: 'Panda 4\' Backed Bench - $398' },
              { value: '{ "code": "B4-H", "description": "Hippopotamus 4\' Backed Bench", "price": "385", "img": "benches/hippo-4" }', text: 'Hippopotamus 4\' Backed Bench - $385' },
              { value: '{ "code": "B4-TP", "description": "Tapir 4\' Backed Bench", "price": "360", "img": "benches/tapir-4" }', text: 'Tapir 4\' Backed Bench - $360' },
              { value: '{ "code": "B4-RP", "description": "Red Panda 4\' Backed Bench", "price": "369", "img": "benches/red-panda-4" }', text: 'Red Panda 4\' Backed Bench - $369' }
            ]
          },
          {
            label: '4\' Backed Benches with arms',
            options: [
              { value: '{ "code": "A4-SL", "description": "Snow Leopard 4\' Backed Bench with arms", "price": "512", "img": "benches/snow-leopard-4-arms" }', text: 'Snow Leopard 4\' Backed Bench with arms - $512' },
              { value: '{ "code": "A4-L", "description": "Lynx 4\' Backed Bench with arms", "price": "459", "img": "benches/lynx-4-arms" }', text: 'Lynx 4\' Backed Bench with arms - $459' },
              { value: '{ "code": "A4-W", "description": "Whale 4\' Backed Bench with arms", "price": "664", "img": "benches/whale-4-arms" }', text: 'Whale 4\' Backed Bench with arms - $664' },
              { value: '{ "code": "A4-T", "description": "Tiger 4\' Backed Bench with arms", "price": "425", "img": "benches/tiger-4-arms" }', text: 'Tiger 4\' Backed Bench with arms - $425' },
              { value: '{ "code": "A4-R", "description": "Rhinoceros 4\' Backed Bench with arms", "price": "446", "img": "benches/rhino-4-arms" }', text: 'Rhinoceros 4\' Backed Bench with arms - $446' },
              { value: '{ "code": "A4-LN", "description": "Lion 4\' Backed Bench with arms", "price": "481", "img": "benches/lion-4-arms" }', text: 'Lion 4\' Backed Bench with arms - $481' },
              { value: '{ "code": "A4-C", "description": "Cheetah 4\' Backed Bench with arms", "price": "581", "img": "benches/cheetah-4-arms" }', text: 'Cheetah 4\' Backed Bench with arms - $581' },
              { value: '{ "code": "A4-P", "description": "Panda 4\' Backed Bench with arms", "price": "506", "img": "benches/panda-4-arms" }', text: 'Panda 4\' Backed Bench with arms - $506' },
              { value: '{ "code": "A4-H", "description": "Hippopotamus 4\' Backed Bench with arms", "price": "520", "img": "benches/hippo-4-arms" }', text: 'Hippopotamus 4\' Backed Bench with arms - 520' },
              { value: '{ "code": "A4-TP", "description": "Tapir 4\' Backed Bench with arms", "price": "468", "img": "benches/tapir-4-arms" }', text: 'Tapir 4\' Backed Bench with arms - $468' },
              { value: '{ "code": "A4-RP", "description": "Red Panda 4\' Backed Bench with arms", "price": "466", "img": "benches/red-panda-4-arms" }', text: 'Red Panda 4\' Backed Bench with arms - $466' }
            ]
          },
          {
            label: '4\' Flat Benches',
            options: [
              { value: '{ "code": "F4-SL", "description": "Snow Leopard 4\' Flat Bench", "price": "246", "img": "benches/snow-leopard-4-flat" }', text: 'Snow Leopard 4\' Flat Bench - $246' },
              { value: '{ "code": "F4-L", "description": "Lynx 4\' Flat Bench", "price": "247", "img": "benches/lynx-4-flat" }', text: 'Lynx 4\' Flat Bench - $247' },
              { value: '{ "code": "F4-W", "description": "Whale 4\' Flat Bench", "price": "339", "img": "benches/whale-4-flat" }', text: 'Whale 4\' Flat Bench - $339' },
              { value: '{ "code": "F4-R", "description": "Rhinoceros 4\' Flat Bench", "price": "242", "img": "benches/rhino-4-flat" }', text: 'Rhinoceros 4\' Flat Bench - $242' },
              { value: '{ "code": "F4-LN", "description": "Lion 4\' Flat Bench", "price": "180", "img": "benches/lion-4-flat" }', text: 'Lion 4\' Flat Bench - $180' },
              { value: '{ "code": "F4-P", "description": "Panda 4\' Flat Bench", "price": "240", "img": "benches/panda-4-flat" }', text: 'Panda 4\' Flat Bench - $240' },
              { value: '{ "code": "F4-TP", "description": "Tapir 4\' Flat Bench", "price": "257", "img": "benches/tapir-4-flat" }', text: 'Tapir 4\' Flat Bench - $257' }
            ]
          },
          {
            label: '4\' ADA Benches',
            options: [
              { value: '{ "code": "ADA-4", "description": "Dolphin 4\' Backed Bench with arms", "price": "664", "img": "benches/dolphin-4" }', text: 'Dolphin 4\' Backed Bench with arms - $664' }
            ]
          },
          {
            label: '6\' Backed Benches',
            options: [
              { value: '{ "code": "B6-SL", "description": "Snow Leopard 6\' Backed Bench", "price": "664", "img": "benches/snow-leopard-6" }', text: 'Snow Leopard 6\' Backed Bench - $664' },
              { value: '{ "code": "B6-L", "description": "Lynx 6\' Backed Bench", "price": "487", "img": "benches/lynx-6" }', text: 'Lynx 6\' Backed Bench - $487' },
              { value: '{ "code": "B6-W", "description": "Whale 6\' Backed Bench", "price": "758", "img": "benches/whale-6" }', text: 'Whale 6\' Backed Bench - $758' },
              { value: '{ "code": "B6-T", "description": "Tiger 6\' Backed Bench", "price": "428", "img": "benches/tiger-6" }', text: 'Tiger 6\' Backed Bench - $428' },
              { value: '{ "code": "B6-R", "description": "Rhinoceros 6\' Backed Bench", "price": "452", "img": "benches/rhino-6" }', text: 'Rhinoceros 6\' Backed Bench - $452' },
              { value: '{ "code": "B6-LN", "description": "Lion 6\' Backed Bench", "price": "520", "img": "benches/lion-6" }', text: 'Lion 6\' Backed Bench - $520' },
              { value: '{ "code": "B6-C", "description": "Cheetah 6\' Backed Bench", "price": "570", "img": "benches/cheetah-6" }', text: 'Cheetah 6\' Backed Bench - $570' },
              { value: '{ "code": "B6-P", "description": "Panda 6\' Backed Bench", "price": "562", "img": "benches/panda-6" }', text: 'Panda 6\' Backed Bench - $562' },
              { value: '{ "code": "B6-H", "description": "Hippopotamus 6\' Backed Bench", "price": "682", "img": "benches/hippo-6" }', text: 'Hippopotamus 6\' Backed Bench - $682' },
              { value: '{ "code": "B6-TP", "description": "Tapir 6\' Backed Bench", "price": "546", "img": "benches/tapir-6" }', text: 'Tapir 6\' Backed Bench - $546' },
              { value: '{ "code": "B6-RP", "description": "Red Panda 6\' Backed Bench", "price": "640", "img": "benches/red-panda-6" }', text: 'Red Panda 6\' Backed Bench - $640' }
            ]
          },
          {
            label: '6\' Backed Benches with arms',
            options: [
              { value: '{ "code": "A6-SL", "description": "Snow Leopard 6\' Backed Bench with arms", "price": "799", "img": "benches/snow-leopard-6-arms" }', text: 'Snow Leopard 6\' Backed Bench with arms - $799' },
              { value: '{ "code": "A6-L", "description": "Lynx 6\' Backed Bench with arms", "price": "595", "img": "benches/lynx-6-arms" }', text: 'Lynx 6\' Backed Bench with arms - $595' },
              { value: '{ "code": "A6-W", "description": "Whale 6\' Backed Bench with arms", "price": "898", "img": "benches/whale-6-arms" }', text: 'Whale 6\' Backed Bench with arms - $898' },
              { value: '{ "code": "A6-T", "description": "Tiger 6\' Backed Bench with arms", "price": "536", "img": "benches/tiger-6-arms" }', text: 'Tiger 6\' Backed Bench with arms - $536' },
              { value: '{ "code": "A6-R", "description": "Rhinoceros 6\' Backed Bench with arms", "price": "560", "img": "benches/rhino-6-arms" }', text: 'Rhinoceros 6\' Backed Bench with arms - $560' },
              { value: '{ "code": "A6-LN", "description": "Lion 6\' Backed Bench with arms", "price": "628", "img": "benches/lion-6-arms" }', text: 'Lion 6\' Backed Bench with arms - $628' },
              { value: '{ "code": "A6-C", "description": "Cheetah 6\' Backed Bench with arms", "price": "756", "img": "benches/cheetah-6-arms" }', text: 'Cheetah 6\' Backed Bench with arms - $756' },
              { value: '{ "code": "A6-P", "description": "Panda 6\' Backed Bench with arms", "price": "670", "img": "benches/panda-6-arms" }', text: 'Panda 6\' Backed Bench with arms - $670' },
              { value: '{ "code": "A6-H", "description": "Hippopotamus 6\' Backed Bench with arms", "price": "605", "img": "benches/hippo-6-arms" }', text: 'Hippopotamus 6\' Backed Bench with arms - $605' },
              { value: '{ "code": "A6-TP", "description": "Tapir 6\' Backed Bench with arms", "price": "655", "img": "benches/tapir-6-arms" }', text: 'Tapir 6\' Backed Bench with arms - $655' },
              { value: '{ "code": "A6-RP", "description": "Red Panda 6\' Backed Bench with arms", "price": "737", "img": "benches/red-panda-6-arms" }', text: 'Red Panda 6\' Backed Bench with arms - $737' }
            ]
          },
          {
            label: '6\' Flat Benches',
            options: [
              { value: '{ "code": "F6-SL", "description": "Snow Leopard 6\' Flat Bench", "price": "369", "img": "benches/snow-leopard-6-flat" }', text: 'Snow Leopard 6\' Flat Bench - $369' },
              { value: '{ "code": "F6-L", "description": "Lynx 6\' Flat Bench", "price": "346", "img": "benches/lynx-6-flat" }', text: 'Lynx 6\' Flat Bench - $346' },
              { value: '{ "code": "F6-W", "description": "Whale 6\' Flat Bench", "price": "458", "img": "benches/whale-6-flat" }', text: 'Whale 6\' Flat Bench - $458' },
              { value: '{ "code": "F6-T", "description": "Tiger 6\' Flat Bench", "price": "281", "img": "benches/tiger-6-flat" }', text: 'Tiger 6\' Flat Bench - $281' },
              { value: '{ "code": "F6-R", "description": "Rhinoceros 6\' Flat Bench", "price": "351", "img": "benches/rhino-6-flat" }', text: 'Rhinoceros 6\' Flat Bench - $351' },
              { value: '{ "code": "F6-LN", "description": "Lion 6\' Flat Bench", "price": "252", "img": "benches/lion-6-flat" }', text: 'Lion 6\' Flat Bench - $252' },
              { value: '{ "code": "F6-P", "description": "Panda 6\' Flat Bench", "price": "349", "img": "benches/panda-6-flat" }', text: 'Panda 6\' Flat Bench - $349' },
              { value: '{ "code": "F6-TP", "description": "Tapir 6\' Flat Bench", "price": "422", "img": "benches/tapir-6-flat" }', text: 'Tapir 6\' Flat Bench - $422' }
            ]
          },
          {
            label: '6\' ADA Benches',
            options: [
              { value: '{ "code": "ADA-6", "description": "Dolphin 6\' Backed Bench with arms", "price": "833", "img": "benches/dolphin-6" }', text: 'Dolphin 6\' Backed Bench with arms - $833' }
            ]
          },
          {
            label: '8\' Backed Benches',
            options: [
              { value: '{ "code": "B8-SL", "description": "Snow Leopard 8\' Backed Bench", "price": "807", "img": "benches/snow-leopard-8" }', text: 'Snow Leopard 8\' Backed Bench - $807' },
              { value: '{ "code": "B8-L", "description": "Lynx 8\' Backed Bench", "price": "650", "img": "benches/lynx-8" }', text: 'Lynx 8\' Backed Bench - $650' },
              { value: '{ "code": "B8-W", "description": "Whale 8\' Backed Bench", "price": "902", "img": "benches/whale-8" }', text: 'Whale 8\' Backed Bench - $902' },
              { value: '{ "code": "B8-T", "description": "Tiger 8\' Backed Bench", "price": "542", "img": "benches/tiger-8" }', text: 'Tiger 8\' Backed Bench - $542' },
              { value: '{ "code": "B8-R", "description": "Rhinoceros 8\' Backed Bench", "price": "598", "img": "benches/rhino-8" }', text: 'Rhinoceros 8\' Backed Bench - $598' },
              { value: '{ "code": "B8-LN", "description": "Lion 8\' Backed Bench", "price": "657", "img": "benches/lion-8" }', text: 'Lion 8\' Backed Bench - $657' },
              { value: '{ "code": "B8-C", "description": "Cheetah 8\' Backed Bench", "price": "731", "img": "benches/cheetah-8" }', text: 'Cheetah 8\' Backed Bench - $731' },
              { value: '{ "code": "B8-P", "description": "Panda 8\' Backed Bench", "price": "696", "img": "benches/panda-8" }', text: 'Panda 8\' Backed Bench - $696' },
              { value: '{ "code": "B8-H", "description": "Hippopotamus 8\' Backed Bench", "price": "815", "img": "benches/hippo-8" }', text: 'Hippopotamus 8\' Backed Bench - $815' },
              { value: '{ "code": "B8-TP", "description": "Tapir 8\' Backed Bench", "price": "657", "img": "benches/tapir-8" }', text: 'Tapir 8\' Backed Bench - $657' },
              { value: '{ "code": "B8-RP", "description": "Red Panda 8\' Backed Bench", "price": "776", "img": "benches/red-panda-8" }', text: 'Red Panda 8\' Backed Bench - $776' }
            ]
          },
          {
            label: '8\' Backed Benches with arms',
            options: [
              { value: '{ "code": "A8-SL", "description": "Snow Leopard 8\' Backed Bench with arms", "price": "942", "img": "benches/snow-leopard-8-arms" }', text: 'Snow Leopard 8\' Backed Bench with arms - $942' },
              { value: '{ "code": "A8-L", "description": "Lynx 8\' Backed Bench with arms", "price": "759", "img": "benches/lynx-8-arms" }', text: 'Lynx 8\' Backed Bench with arms - $759' },
              { value: '{ "code": "A8-W", "description": "Whale 8\' Backed Bench with arms", "price": "1042", "img": "benches/whale-8-arms" }', text: 'Whale 8\' Backed Bench with arms - $1,042' },
              { value: '{ "code": "A8-T", "description": "Tiger 8\' Backed Bench with arms", "price": "649", "img": "benches/tiger-8-arms" }', text: 'Tiger 8\' Backed Bench with arms - $649' },
              { value: '{ "code": "A8-R", "description": "Rhinoceros 8\' Backed Bench with arms", "price": "706", "img": "benches/rhino-8-arms" }', text: 'Rhinoceros 8\' Backed Bench with arms - $706' },
              { value: '{ "code": "A8-LN", "description": "Lion 8\' Backed Bench with arms", "price": "764", "img": "benches/lion-8-arms" }', text: 'Lion 8\' Backed Bench with arms - $764' },
              { value: '{ "code": "A8-C", "description": "Cheetah 8\' Backed Bench with arms", "price": "918", "img": "benches/cheetah-8-arms" }', text: 'Cheetah 8\' Backed Bench with arms - $918' },
              { value: '{ "code": "A8-P", "description": "Panda 8\' Backed Bench with arms", "price": "803", "img": "benches/panda-8-arms" }', text: 'Panda 8\' Backed Bench with arms - $803' },
              { value: '{ "code": "A8-H", "description": "Hippopotamus 8\' Backed Bench with arms", "price": "950", "img": "benches/hippo-8-arms" }', text: 'Hippopotamus 8\' Backed Bench with arms - $950' },
              { value: '{ "code": "A8-TP", "description": "Tapir 8\' Backed Bench with arms", "price": "764", "img": "benches/tapir-8-arms" }', text: 'Tapir 8\' Backed Bench with arms - $764' },
              { value: '{ "code": "A8-RP", "description": "Red Panda 8\' Backed Bench with arms", "price": "873", "img": "benches/red-panda-8-arms" }', text: 'Red Panda 8\' Backed Bench with arms - $873' }
            ]
          },
          {
            label: '8\' Flat Benches',
            options: [
              { value: '{ "code": "F8-SL", "description": "Snow Leopard 8\' Flat Bench", "price": "460", "img": "benches/snow-leopard-8-flat" }', text: 'Snow Leopard 8\' Flat Bench - $460' },
              { value: '{ "code": "F8-L", "description": "Lynx 8\' Flat Bench", "price": "453", "img": "benches/lynx-8-flat" }', text: 'Lynx 8\' Flat Bench - $453' },
              { value: '{ "code": "F8-W", "description": "Whale 8\' Flat Bench", "price": "598", "img": "benches/whale-8-flat" }', text: 'Whale 8\' Flat Bench - $598' },
              { value: '{ "code": "F8-T", "description": "Tiger 8\' Flat Bench", "price": "382", "img": "benches/tiger-8-flat" }', text: 'Tiger 8\' Flat Bench - $382' },
              { value: '{ "code": "F8-R", "description": "Rhinoceros 8\' Flat Bench", "price": "456", "img": "benches/rhino-8-flat" }', text: 'Rhinoceros 8\' Flat Bench - $456' },
              { value: '{ "code": "F8-LN", "description": "Lion 8\' Flat Bench", "price": "334", "img": "benches/lion-8-flat" }', text: 'Lion 8\' Flat Bench - $334' },
              { value: '{ "code": "F8-P", "description": "Panda 8\' Flat Bench", "price": "438", "img": "benches/panda-8-flat" }', text: 'Panda 8\' Flat Bench - $438' },
              { value: '{ "code": "F8-TP", "description": "Tapir 8\' Flat Bench", "price": "435", "img": "benches/tapir-8-flat" }', text: 'Tapir 8\' Flat Bench - $435' }
            ]
          },
          {
            label: '8\' ADA Benches',
            options: [
              { value: '{ "code": "ADA-8", "description": "Dolphin 8\' Backed Bench with arms", "price": "1012", "img": "benches/dolphin-8" }', text: 'Dolphin 8\' Backed Bench with arms - $1,012' }
            ]
          }
        ],
        amenityFacilities: [
          { value: null, text: 'Please select an option' },
          {
            label: 'Message Centers',
            options: [
              { value: '{ "code": "MC-SBC", "description": "Conure Small Bulletin Case", "price": "526", "img": "facilities/conure-small-case" }', text: 'Conure Small Bulletin Case - $526' },
              { value: '{ "code": "MC-SBCP8", "description": "Conure Single-sided Small Bulletin Case with 8\' Post", "price": "625", "img": "facilities/conure-single" }', text: 'Conure Single-sided Small Bulletin Case with 8\' Post - $625' },
              { value: '{ "code": "MC-DSSBCP8", "description": "Conure Double-sided Small Bulletin Case with 8\' Post", "price": "830", "img": "facilities/conure-double" }', text: 'Conure Double-sided Small Bulletin Case with 8\' Post - $830' },
              { value: '{ "code": "MC-MBC", "description": "Parrot Medium Bulletin Case", "price": "755", "img": "facilities/parrot-medium" }', text: 'Parrot Medium Bulletin Case - $755' },
              { value: '{ "code": "MC-MBCP8", "description": "Parrot Single-sided Medium Bulletin Case with 8\' Posts", "price": "957", "img": "facilities/parrot-single" }', text: 'Parrot Single-sided Medium Bulletin Case with 8\' Posts - $957' },
              { value: '{ "code": "MC-DSMBCP8", "description": "Parrot Double-sided Medium Bulletin Case with 8\' Posts", "price": "1218", "img": "facilities/parrot-double" }', text: 'Parrot Double-sided Medium Bulletin Case with 8\' Posts - $1,218' },
              { value: '{ "code": "MC-LBC", "description": "Macaw Large Bulletin Case", "price": "938", "img": "facilities/macaw-large" }', text: 'Macaw Large Bulletin Case - $938' },
              { value: '{ "code": "MC-LBCP8", "description": "Macaw Single-sided Large Bulletin Case with 8\' Posts", "price": "1245", "img": "facilities/macaw-single" }', text: 'Macaw Single-sided Large Bulletin Case with 8\' Posts - $1,245' },
              { value: '{ "code": "MC-DSLBCP8", "description": "Macaw Double-sided Large Bulletin Case with 8\' Posts", "price": "1665", "img": "facilities/macaw-double" }', text: 'Macaw Double-sided Large Bulletin Case with 8\' Posts - $1,665' },
              { value: '{ "code": "MC-TSKBCP8", "description": "Kakapo Three-sided Kiosk Bulletin Case with 8\' Posts", "price": "2850", "img": "facilities/kakapo" }', text: 'Kakapo Three-sided Kiosk Bulletin Case with 8\' Posts - $2,850' },
              { value: '{ "code": "MC-LPBCP6", "description": "Amazon Low-profile Bulletin Case with 6\' Posts", "price": "996", "img": "facilities/amazon" }', text: 'Amazon Low-profile Bulletin Case with 6\' Posts - $996' }
            ]
          },
          {
            label: 'Message Center Accessories',
            options: [
              { value: '{ "code": "MCA-SPM", "description": "Surface Post Mount", "price": "34", "img": "facilities/surface-post" }', text: 'Surface Post Mount - $34' },
              { value: '{ "code": "MSA-IGPMA", "description": "In-ground Post Mounting Anchor", "price": "41", "img": "facilities/in-ground" }', text: 'In-ground Post Mounting Anchor - $41' },
              { value: '{ "code": "MSA-LLR", "description": "Macaw Large Literature Rack", "price": "520", "img": "facilities/macaw-rack" }', text: 'Macaw Large Literature Rack - $520' },
              { value: '{ "code": "MSA-MLR", "description": "Parrot Medium Literature Rack", "price": "439", "img": "facilities/parrot-rack" }', text: 'Parrot Medium Literature Rack - $439' },
              { value: '{ "code": "MSA-SLR", "description": "Conure Small Literature Rack", "price": "219", "img": "facilities/conure-rack" }', text: 'Conure Small Literature Rack - $219' }
              // { value: '{ "code": "MSA-TLR", "description": "Triple Literature Rack", "price": "289", "img": "facilities/triple-rack" }', text: 'Triple Literature Rack - $289' }
            ]
          }
        ],
        amenityReceptacles: [
          { value: null, text: 'Please select an option' },
          {
            label: 'Trash Receptacles',
            options: [
              { value: '{ "code": "TR-R14D", "description": "Round 14 Double", "price": "566", "img": "receptacles/double-14" }', text: 'Round 14 Double - $566' },
              { value: '{ "code": "TR-S22", "description": "Square 22", "price": "410", "img": "receptacles/square-22" }', text: 'Square 22 - $410' },
              { value: '{ "code": "TR-HR14", "description": "Half Round 14", "price": "381", "img": "receptacles/half-round-14" }', text: 'Half Round 14 - $381' },
              { value: '{ "code": "TR-R33", "description": "Round 33", "price": "630", "img": "receptacles/round-33" }', text: 'Round 33 - $630' },
              { value: '{ "code": "TR-R33C", "description": "Round 33 with Cap", "price": "760", "img": "receptacles/round-33-cap" }', text: 'Round 33 with Cap - $760' },
              { value: '{ "code": "TR-RF33", "description": "Round Flare 33", "price": "986", "img": "receptacles/round-flare-33" }', text: 'Round Flare 33 - $986' },
              { value: '{ "code": "TR-RF33C", "description": "Round Flare 33 with Cap", "price": "1116", "img": "receptacles/round-flare-33-cap" }', text: 'Round Flare 33 with Cap - $1,116' },
              { value: '{ "code": "TR-S32", "description": "Square 32", "price": "1149", "img": "receptacles/square-32" }', text: 'Square 32 - $1,149' },
              { value: '{ "code": "TR-S32D", "description": "Square 32 Double", "price": "1774", "img": "receptacles/square-32-double" }', text: 'Square 32 Double - $1,774' },
              { value: '{ "code": "TR-S32T", "description": "Square 32 Triple", "price": "2430", "img": "receptacles/square-32-triple" }', text: 'Square 32 Triple - $2,430' },
              { value: '{ "code": "TR-S40", "description": "Square 40", "price": "1100", "img": "receptacles/square-40" }', text: 'Square 40 - $1,100' },
              { value: '{ "code": "TR-S40C", "description": "Square 40 with Cap", "price": "1257", "img": "receptacles/square-40-cap" }', text: 'Square 40 with Cap - $1,257' }
            ]
          },
          {
            label: 'Recycle Receptacles',
            options: [
              { value: '{ "code": "TR-S40R", "description": "Square 40 Recycling", "price": "1257", "img": "receptacles/square-40-recycling" }', text: 'Square 40 Recycling - $1257' }
              // { value: '{ "code": "TR-R49", "description": "Round 49", "price": "628", "img": "receptacles/round-49" }', text: 'Round 49 - $628' },
              // { value: '{ "code": "TR-R49C", "description": "Round 49 with Cap", "price": "817", "img": "receptacles/round-49-cap" }', text: 'Round 49 with Cap - $817' },
              // { value: '{ "code": "TR-R49D", "description": "Round 49 Double", "price": "1346", "img": "receptacles/round-49-double" }', text: 'Round 49 Double - $1346' },
              // { value: '{ "code": "TR-R49T", "description": "Round 49 Triple", "price": "1963", "img": "receptacles/round-49-triple" }', text: 'Round 49 Triple - $1963' }
            ]
          }
        ],
        amenityTables: [
          { value: null, text: 'Please select an option' },
          {
            label: '4\' Rectangle Picnic Tables',
            options: [
              { value: '{ "code": "PT-M", "description": "Monkey 4\' Picnic Table", "price": "836", "img": "tables/monkey" }', text: 'Monkey 4\' Picnic Table - $836' }
            ]
          },
          {
            label: '6\' Rectangle Picnic Tables',
            options: [
              { value: '{ "code": "PT-O6", "description": "Orangutan 6\' Picnic Table", "price": "1231", "img": "tables/orangutan-6" }', text: 'Orangutan 6\' Picnic Table - $1,231' },
              { value: '{ "code": "PT-O6DS", "description": "Orangutan 6\' Picnic Table w/ Detached Seats", "price": "1515", "img": "tables/orangutan-6-detached" }', text: 'Orangutan 6\' Picnic Table w/ Detached Seats - $1,515' },
              { value: '{ "code": "PT-L6", "description": "Langur 6\' Easy Access Picnic Table", "price": "1172", "img": "tables/langur-6" }', text: 'Langur 6\' Easy Access Picnic Table - $1,172' },
              // { value: '{ "code": "PT-M6", "description": "Macaque 6\' Step-thru Picnic Table", "price": "1053", "img": "tables/macaque-6" }', text: 'Macaque 6\' Step-thru Picnic Table - $1053' },
              { value: '{ "code": "PT-C6", "description": "Chimpanzee 6\' Picnic Table", "price": "1152", "img": "tables/chimp-6" }', text: 'Chimpanzee 6\' Picnic Table - $1,152' }
            ]
          },
          {
            label: '8\' Rectangle Picnic Tables',
            options: [
              { value: '{ "code": "PT-O8", "description": "Orangutan 8\' Picnic Table", "price": "1408", "img": "tables/orangutan-8" }', text: 'Orangutan 8\' Picnic Table - $1,408' },
              { value: '{ "code": "PT-L8", "description": "Langur 8\' Easy Access Picnic Table", "price": "1388", "img": "tables/langur-8" }', text: 'Langur 8\' Easy Access Picnic Table - $1,388' },
              // { value: '{ "code": "PT-M8", "description": "Macaque 8\' Step-thru Picnic Table", "price": "1207", "img": "tables/macaque-8" }', text: 'Macaque 8\' Step-thru Picnic Table - $1207' },
              { value: '{ "code": "PT-C8", "description": "Chimpanzee 8\' Picnic Table", "price": "1365", "img": "tables/chimp-8" }', text: 'Chimpanzee 8\' Picnic Table - $1,365' }
            ]
          },
          {
            label: 'Universal Access Tables',
            options: [
              { value: '{ "code": "PT-GHA", "description": "Gorilla Handicap Accessible Picnic Table", "price": "1916", "img": "tables/gorilla" }', text: 'Gorilla Handicap Accessible Picnic Table - $1,916' },
              { value: '{ "code": "PT-OHA", "description": "Orangutan Handicap Accessible Picnic Table", "price": "1415", "img": "tables/orangutan-handicap" }', text: 'Orangutan Handicap Accessible Picnic Table - $1,415' },
              // { value: '{ "code": "PT-GOHA", "description": "Gibbon Open Hexagon Handicap Accessible Picnic Table", "price": "869", "img": "tables/gibbon-handicap" }', text: 'Gibbon Open Hexagon Handicap Accessible Picnic Table - $869' },
              // { value: '{ "code": "PT-CHA", "description": "Colobus Plaza Handicap Accessible Picnic Table", "price": "836", "img": "tables/colobus-handicap" }', text: 'Colobus Plaza Handicap Accessible Picnic Table - $836' },
              { value: '{ "code": "PT-LHA", "description": "Langur Easy Access Handicap Accessible Picnic Table", "price": "1366", "img": "tables/langur-handicap" }', text: 'Langur Easy Access Handicap Accessible Picnic Table - $1,366' },
              // { value: '{ "code": "PT-MHA", "description": "Macaque Step-thru Handicap Accessible Picnic Table", "price": "1188", "img": "tables/macaque-handicap" }', text: 'Macaque Step-thru Handicap Accessible Picnic Table - $1188' },
              { value: '{ "code": "PT-CHAT", "description": "Chimpanzee Handicap Accessible Picnic Table", "price": "1343", "img": "tables/chimp-handicap" }', text: 'Chimpanzee Handicap Accessible Picnic Table - $1,343' }
            ]
          },
          {
            label: 'Hexagon Picnic Tables',
            options: [
              // { value: '{ "code": "PT-GEH", "description": "Gibbon Economizer Hexagon Picnic Table", "price": "884", "img": "tables/gibbon-economizer" }', text: 'Gibbon Economizer Hexagon Picnic Table - $884' },
              // { value: '{ "code": "PT-CEH", "description": "Colobus Economizer Hexagon Picnic Table", "price": "849", "img": "tables/colobus-economizer" }', text: 'Colobus Economizer Hexagon Picnic Table - $849' },
              { value: '{ "code": "PT-GOH", "description": "Gibbon Open Hexagon Picnic Table", "price": "1195", "img": "tables/gibbon-open" }', text: 'Gibbon Open Hexagon Picnic Table - $1,195' },
              { value: '{ "code": "PT-CPH", "description": "Colobus Plaza Hexagon Picnic Table", "price": "1094", "img": "tables/colobus-plaza" }', text: 'Colobus Plaza Hexagon Picnic Table - $1,094' }
            ]
          },
          {
            label: 'Round Picnic Tables',
            options: [
              { value: '{ "code": "PT-LR", "description": "Loris Picnic Table", "price": "1224", "img": "tables/loris" }', text: 'Loris Picnic Table - $1,224' },
              { value: '{ "code": "PT-LMR", "description": "Lemur Picnic Table", "price": "1380", "img": "tables/lemur" }', text: 'Lemur Picnic Table - $1,380' },
              { value: '{ "code": "PT-GR", "description": "Guenon Picnic Table", "price": "1548", "img": "tables/guenon" }', text: 'Guenon Picnic Table - $1,548' }
            ]
          },
          {
            label: 'Square Picnic Tables',
            options: [
              { value: '{ "code": "PT-TS", "description": "Tarsier Square Picnic Table", "price": "1509", "img": "tables/tarsier" }', text: 'Tarsier Square Picnic Table - $1,509' },
              { value: '{ "code": "PT-KS", "description": "Kipunji Picnic Table", "price": "1462", "img": "tables/kipunji" }', text: 'Kipunji Picnic Table - $1,462' }
            ]
          },
          {
            label: 'Youth Picnic Tables',
            options: [
              { value: '{ "code": "PT-BM", "description": "Baby Monkey Kid Size Picnic Table", "price": "757", "img": "tables/baby-monkey" }', text: 'Baby Monkey Kid Size Picnic Table - $757' },
              { value: '{ "code": "PT-BG", "description": "Baby Gibbon Kid Size Open Hexagon Picnic Table", "price": "764", "img": "tables/baby-gibbon" }', text: 'Baby Gibbon Kid Size Open Hexagon Picnic Table - $764' },
              { value: '{ "code": "PT-BL", "description": "Baby Lemur Picnic Table", "price": "1041", "img": "tables/baby-lemur" }', text: 'Baby Lemur Picnic Table - $1,041' }
            ]
          }
        ],
        howDidYouHear: [
          { value: 'NAI Conference', text: 'NAI Conference' },
          { value: 'NAI Legacy Magazine', text: 'NAI Legacy Magazine' },
          { value: 'NAI Website', text: 'NAI Website' },
          { value: 'OPRA Conference', text: 'OPRA Conference' },
          { value: 'OPRA Magazine', text: 'OPRA Magazine' },
          { value: 'Google Search', text: 'Google Search' },
          { value: 'Referral', text: 'Referral' },
          { value: 'Previous Customer', text: 'Previous Customer' },
          { value: 'Other', text: 'Other' }
        ],
        novalloyGraphics: [
          { value: null, text: 'Please select an option' },
          { value: '{ "mount": "1037", "code": "1006", "price": "415.00", "description": "8\\"x10\\" Novalloy, No Halftones" }', text: '8"x10" Novalloy, No Halftones - $415.00' },
          { value: '{ "mount": "1037", "code": "1007", "price": "415.00", "description": "8\\"x10\\" Novalloy, Halftones" }', text: '8"x10" Novalloy, Halftones - $415.00' },
          { value: '{ "mount": "1037", "code": "1008", "price": "415.00", "description": "8\\"x10\\" Novalloy, 3-color" }', text: '8"x10" Novalloy, 3-color - $415.00' },
          { value: '{ "mount": "1028", "code": "1009", "price": "771.00", "description": "12\\"x16\\" Novalloy, No Halftones" }', text: '12"x16" Novalloy, No Halftones - $771.00' },
          { value: '{ "mount": "1028", "code": "1010", "price": "771.00", "description": "12\\"x16\\" Novalloy, Halftones" }', text: '12"x16" Novalloy, Halftones - $771.00' },
          { value: '{ "mount": "1028", "code": "1011", "price": "771.00", "description": "12\\"x16\\" Novalloy, 3-color" }', text: '12"x16" Novalloy, 3-color - $771.00' },
          { value: '{ "mount": "1028", "code": "1012", "price": "1521.00", "description": "18\\"x24\\" Novalloy, No Halftones" }', text: '18"x24" Novalloy, No Halftones - $1,521.00' },
          { value: '{ "mount": "1028", "code": "1013", "price": "1521.00", "description": "18\\"x24\\" Novalloy, Halftones" }', text: '18"x24" Novalloy, Halftones - $1,521.00' },
          { value: '{ "mount": "1028", "code": "1014", "price": "1521.00", "description": "18\\"x24\\" Novalloy, 3-color" }', text: '18"x24" Novalloy, 3-color - $1,521.00' },
          { value: '{ "mount": "1028", "code": "1015", "price": "1845.00", "description": "18\\"x30\\" Novalloy, No Halftones" }', text: '18"x30" Novalloy, No Halftones - $1,845.00' },
          { value: '{ "mount": "1028", "code": "1016", "price": "1845.00", "description": "18\\"x30\\" Novalloy, Halftones" }', text: '18"x30" Novalloy, Halftones - $1,845.00' },
          { value: '{ "mount": "1028", "code": "1017", "price": "1845.00", "description": "18\\"x30\\" Novalloy, 3-color" }', text: '18"x30" Novalloy, 3-color - $1,845.00' },
          { value: '{ "mount": "1028", "code": "1018", "price": "2385.00", "description": "24\\"x30\\" Novalloy, No Halftones" }', text: '24"x30" Novalloy, No Halftones - $2,385.00' },
          { value: '{ "mount": "1028", "code": "1019", "price": "2385.00", "description": "24\\"x30\\" Novalloy, Halftones" }', text: '24"x30" Novalloy, Halftones - $2,385.00' },
          { value: '{ "mount": "1028", "code": "1020", "price": "2385.00", "description": "24\\"x30\\" Novalloy, 3-color" }', text: '24"x30" Novalloy, 3-color - $2,385.00' },
          { value: '{ "mount": "1028", "code": "1021", "price": "2817.00", "description": "24\\"x36\\" Novalloy, No Halftones" }', text: '24"x36" Novalloy, No Halftones - $2,817.00' },
          { value: '{ "mount": "1028", "code": "1022", "price": "2817.00", "description": "24\\"x36\\" Novalloy, Halftones" }', text: '24"x36" Novalloy, Halftones - $2,817.00' },
          { value: '{ "mount": "1028", "code": "1023", "price": "2817.00", "description": "24\\"x36\\" Novalloy, 3-color" }', text: '24"x36" Novalloy, 3-color - $2,817.00' },
          { value: '{ "mount": "1038", "code": "1024", "price": "2817.00", "description": "24\\"x36\\" Novalloy, No Halftones, 8 Taps" }', text: '24"x36" Novalloy, No Halftones, 8 Taps - $2,817.00' },
          { value: '{ "mount": "1038", "code": "1025", "price": "2817.00", "description": "24\\"x36\\" Novalloy, Halftones, 8 Taps" }', text: '24"x36" Novalloy, Halftones, 8 Taps - $2,817.00' },
          { value: '{ "mount": "1038", "code": "1026", "price": "2817.00", "description": "24\\"x36\\" Novalloy, 3-color, 8 Taps" }', text: '24"x36" Novalloy, 3-color, 8 Taps - $2,817.00' }
        ],
        novalloyMounting: [
          { value: null, text: 'Please select an option' },
          { value: '{"code": "none", "price": "0", "description": "No Mounting"}', text: 'No Mounting' },
          { value: '{ "mount": "1028", "code": "1028", "price": "295.00", "description": "3\\" Novalloy Post, 10\\"x10\\" Mount Plate" }', text: '3" Novalloy Post, 10"x10" Mount Plate - $295.00' },
          { value: '{ "mount": "1037", "code": "1037", "price": "295.00", "description": "3\\" Novalloy Post, 6\\"x6\\" Mount Plate" }', text: '3" Novalloy Post, 6"x6" Mount Plate - $295.00' },
          { value: '{ "mount": "1038", "code": "1038", "price": "590.00", "description": "Two 3\\" Novalloy Posts, 10\\"x10\\" Mount Plates" }', text: 'Two 3" Novalloy Posts, 10"x10" Mount Plates - $590.00' }
        ],
        mountingStyleOptions: [
          { value: null, text: 'Please select an option' },
          { value: '{"code": "none", "price": "0", "description": "No Mounting"}', text: 'No Mounting' },
          {
            label: 'Mounting Plate with Wood Post Mount Sleeve',
            options: [
              { value: '{ "code": "3000", "price": "82.91", "description": "6\\"x6\\" Mounting Plate" }', text: '6"x6" Mounting Plate - $82.91' },
              { value: '{ "code": "3001", "price": "119.79", "description": "12\\"x12\\" Mounting Plate" }', text: '12"x12" Mounting Plate - $119.79' },
              { value: '{ "code": "3002", "price": "131.18", "description": "12\\"x18\\" Mounting Plate" }', text: '12"x18" Mounting Plate - $131.18' }
            ]
          },
          {
            label: 'Single Pedestal Post',
            options: [
              { value: '{ "code": "3005", "price": "146.36", "description": "Single Pedestal, 6\\"x6\\" Mounting Plate, In-ground" }', text: 'Single Pedestal, 6"x6" Mounting Plate, In-ground - $146.36' },
              { value: '{ "code": "3021", "price": "221.96", "description": "Single Pedestal, 6\\"x6\\" Mounting Plate, Deluxe Surface Mount" }', text: 'Single Pedestal, 6"x6" Mounting Plate, Deluxe Surface Mount - $221.96' },
              { value: '{ "code": "3006", "price": "157.59", "description": "Single Pedestal, 12\\"x12\\" Mounting Plate, In-ground" }', text: 'Single Pedestal, 12"x12" Mounting Plate, In-ground - $157.59' },
              { value: '{ "code": "3022", "price": "233.19", "description": "Single Pedestal, 12\\"x12\\" Mounting Plate, Deluxe Surface Mount" }', text: 'Single Pedestal, 12"x12" Mounting Plate, Deluxe Surface Mount - $233.19' },
              { value: '{ "code": "3007", "price": "165.09", "description": "Single Pedestal, 12\\"x18\\" Mounting Plate, In-ground" }', text: 'Single Pedestal, 12"x18" Mounting Plate, In-ground - $165.09' },
              { value: '{ "code": "3023", "price": "240.69", "description": "Single Pedestal, 12\\"x18\\" Mounting Plate, Deluxe Surface Mount" }', text: 'Single Pedestal, 12"x18" Mounting Plate, Deluxe Surface Mount - $240.69' }
            ]
          },
          {
            label: 'Double Pedestal Posts',
            options: [
              { value: '{ "code": "3010", "price": "315.18", "description": "Double Pedestal 12\\"x12\\" Mounting Plates, In-ground" }', text: 'Double Pedestal 12"x12" Mounting Plates, In-ground - $315.18' },
              { value: '{ "code": "3026", "price": "466.38", "description": "Double Pedestal 12\\"x12\\" Mounting Plates, Deluxe Surface Mount" }', text: 'Double Pedestal 12"x12" Mounting Plates, Deluxe Surface Mount - $466.38' }
            ]
          },
          {
            label: 'Cantilever Pedestals',
            options: [
              { value: '{ "code": "3029", "price": "399.23", "description": "Cantilever Pedestal, 24\\" H, In-ground" }', text: 'Cantilever Pedestal, 24" H, In-ground - $399.23' },
              { value: '{ "code": "3033", "price": "550.43", "description": "Cantilever Pedestal, 24\\" H Panel, Deluxe Surface Mount" }', text: 'Cantilever Pedestal, 24" H Panel, Deluxe Surface Mount - $550.43' }
            ]
          },
          {
            label: 'Upright Pedestals and Flush Mount Pedestals',
            options: [
              { value: '{ "code": "3042", "price": "478.88", "description": "Upright Pedestal, 36\\" H, In-ground Posts" }', text: 'Upright Pedestal, 36" H, In-ground Posts - $478.88' },
              { value: '{ "code": "3042A", "price": "637.24", "description": "Upright Pedestal, 36\\" H, Deluxe Surface Mount" }', text: 'Upright Pedestal, 36" H, Deluxe Surface Mount - $637.24' },
              { value: '{ "code": "3043", "price": "543.60", "description": "Upright Pedestal, 48\\" H, In-ground Posts" }', text: 'Upright Pedestal, 48" H, In-ground Posts - $543.60' },
              { value: '{ "code": "3043A", "price": "677.23", "description": "Upright Pedestal, 48\\" H, Deluxe Surface Mount" }', text: 'Upright Pedestal, 48" H, Deluxe Surface Mount - $677.23' },
              { value: '{ "code": "3054", "price": "189.74", "description": "Upright Single Pedestal, 6x6 Mount Plate, In-ground" }', text: 'Upright Single Pedestal, 6x6 Mount Plate, In-ground - $189.74' },
              { value: '{ "code": "3056", "price": "255.89", "description": "Upright Single Pedestal, 6x6 Mount Plate, Deluxe Surface Mount" }', text: 'Upright Single Pedestal, 6x6 Mount Plate, Deluxe Surface Mount - $255.89' },
              { value: '{ "code": "3057", "price": "211.34", "description": "Upright Single Pedestal, 12x12 Mount Plate, In-ground" }', text: 'Upright Single Pedestal, 12x12 Mount Plate, In-ground - $211.34' }
            ]
          },
          {
            label: 'Cantilever Bases/Frames',
            options: [
              { value: '{ "code": "3066", "price": "577.74", "description": "Cantilever Base/Frame, 24x36, In-Ground" }', text: 'Cantilever Base/Frame, 24x36, In-Ground - $577.74' },
              { value: '{ "code": "3070", "price": "724.23", "description": "Cantilever Base/Frame, 24x36, Deluxe Surface Mount" }', text: 'Cantilever Base/Frame, 24x36, Deluxe Surface Mount - $724.23' },
              { value: '{ "code": "3072", "price": "522.18", "description": "Cantilever Base/Frame, 18x24, In-Ground" }', text: 'Cantilever Base/Frame, 18x24, In-Ground - $522.18' },
              { value: '{ "code": "3076", "price": "642.27", "description": "Cantilever Base/Frame, 18x24, Deluxe Surface Mount" }', text: 'Cantilever Base/Frame, 18x24, Deluxe Surface Mount - $642.27' }
            ]
          },
          {
            label: 'Traditional Bases/Frames',
            options: [
              { value: '{ "code": "3067", "price": "577.74", "description": "Traditional Bases/Frames, 24x36, In-Ground" }', text: 'Traditional Bases/Frames, 24x36, In-Ground - $577.74' },
              { value: '{ "code": "3071", "price": "694.23", "description": "Traditional Bases/Frames, 24x36, Deluxe Surface Mount" }', text: 'Traditional Bases/Frames, 24x36, Deluxe Surface Mount - $694.23' },
              { value: '{ "code": "3073", "price": "522.18", "description": "Traditional Bases/Frames, 18x24, In-Ground" }', text: 'Traditional Bases/Frames, 18x24, In-Ground - $522.18' },
              { value: '{ "code": "3077", "price": "667.81", "description": "Traditional Bases/Frames, 18x24, Deluxe Surface Mount" }', text: 'Traditional Bases/Frames, 18x24, Deluxe Surface Mount - $667.81' }
            ]
          },
          {
            label: 'Upright Bases/Frames',
            options: [
              { value: '{ "code": "3084", "price": "612.12", "description": "Upright Base/Frame, 24x36, In-Ground" }', text: 'Upright Base/Frame, 24x36, In-Ground - $612.12' },
              { value: '{ "code": "3085", "price": "612.12", "description": "Upright Base/Frame, 36x24, In-Ground" }', text: 'Upright Base/Frame, 36x24, In-Ground - $612.12' },
              { value: '{ "code": "3086", "price": "888.23", "description": "Upright Base/Frame, 36x48, In-Ground" }', text: 'Upright Base/Frame, 36x48, In-Ground - $888.23' },
              { value: '{ "code": "3087", "price": "888.23", "description": "Upright Base/Frame, 48x36, In-Ground" }', text: 'Upright Base/Frame, 48x36, In-Ground - $888.23' },
              { value: '{ "code": "3088", "price": "1086.05", "description": "Upright Base/Frame, 48x48, In-Ground" }', text: 'Upright Base/Frame, 48x48, In-Ground - $1086.05' },
              { value: '{ "code": "3089", "price": "647.00", "description": "Upright Base/Frame, 24x36, Surface-Mount" }', text: 'Upright Base/Frame, 24x36, Surface-Mount - $647.00' },
              { value: '{ "code": "3090", "price": "647.00", "description": "Upright Base/Frame, 36x24, Surface-Mount" }', text: 'Upright Base/Frame, 36x24, Surface-Mount - $647.00' },
              { value: '{ "code": "3091", "price": "969.23", "description": "Upright Base/Frame, 48x36, Surface-Mount" }', text: 'Upright Base/Frame, 48x36, Surface-Mount - $969.23' },
              { value: '{ "code": "3092", "price": "969.23", "description": "Upright Base/Frame, 36x48, Surface-Mount" }', text: 'Upright Base/Frame, 36x48, Surface-Mount - $969.23' },
              { value: '{ "code": "3093", "price": "1167.05", "description": "Upright Base/Frame, 48x48, Surface-Mount" }', text: 'Upright Base/Frame, 48x48, Surface-Mount - $1,167.05' },
              { value: '{ "code": "3094", "price": "671.00", "description": "Upright Base/Frame, 24x36, Deluxe Surface-Mount" }', text: 'Upright Base/Frame, 24x36, Deluxe Surface-Mount - $671.00' },
              { value: '{ "code": "3095", "price": "671.00", "description": "Upright Base/Frame, 36x24, Deluxe Surface-Mount" }', text: 'Upright Base/Frame, 36x24, Deluxe Surface-Mount - $671.00' },
              { value: '{ "code": "3096", "price": "993.23", "description": "Upright Base/Frame, 48x36, Deluxe Surface-Mount" }', text: 'Upright Base/Frame, 48x36, Deluxe Surface-Mount - $993.23' },
              { value: '{ "code": "3097", "price": "993.23", "description": "Upright Base/Frame, 36x48, Deluxe Surface-Mount" }', text: 'Upright Base/Frame, 36x48, Deluxe Surface-Mount - $993.23' },
              { value: '{ "code": "3098", "price": "1191.05", "description": "Upright Base/Frame, 48x48, Deluxe Surface-Mount" }', text: 'Upright Base/Frame, 48x48, Deluxe Surface-Mount - $1,191.05' }
            ]
          },
          {
            label: 'Pedestals with Frames',
            options: [
              { value: '{ "code": "3099", "price": "399.30", "description": "Single Pedestal with Frame, 18x24, In-Ground" }', text: 'Single Pedestal with Frame, 18x24, In-Ground - $399.30' },
              { value: '{ "code": "3100", "price": "423.80", "description": "Single Pedestal with Frame, 18x24, Surface-Mount" }', text: 'Single Pedestal with Frame, 18x24, Surface-Mount - $423.80' },
              { value: '{ "code": "3101", "price": "474.90", "description": "Single Pedestal with Frame, 18x24, Deluxe Surface-Mount" }', text: 'Single Pedestal with Frame, 18x24, Deluxe Surface-Mount - $474.90' },
              { value: '{ "code": "3102", "price": "569.42", "description": "Single Pedestal with Frame, 24x24, In-Ground" }', text: 'Single Pedestal with Frame, 24x24, In-Ground - $569.42' },
              { value: '{ "code": "3103", "price": "600.92", "description": "Single Pedestal with Frame, 24x24, Surface-Mount" }', text: 'Single Pedestal with Frame, 24x24, Surface-Mount - $600.92' },
              { value: '{ "code": "3104", "price": "641.42", "description": "Single Pedestal with Frame, 24x24, Deluxe Surface-Mount" }', text: 'Single Pedestal with Frame, 24x24, Deluxe Surface-Mount - $641.42' },
              { value: '{ "code": "3105", "price": "451.11", "description": "Single Pedestal with Frame, 24x36, In-Ground" }', text: 'Single Pedestal with Frame, 24x36, In-Ground - $451.11' },
              { value: '{ "code": "3106", "price": "481.04", "description": "Single Pedestal with Frame, 24x36, Surface-Mount" }', text: 'Single Pedestal with Frame, 24x36, Surface-Mount - $481.04' },
              { value: '{ "code": "3107", "price": "526.71", "description": "Single Pedestal with Frame, 24x36, Deluxe Surface-Mount" }', text: 'Single Pedestal with Frame, 24x36, Deluxe Surface-Mount - $526.71' },
              { value: '{ "code": "3108", "price": "362.78", "description": "Single Pedestal with Frame, 8.5x11, In-Ground" }', text: 'Single Pedestal with Frame, 8.5x11, In-Ground - $362.78' },
              { value: '{ "code": "3109", "price": "385.28", "description": "Single Pedestal with Frame, 8.5x11, Surface-Mount" }', text: 'Single Pedestal with Frame, 8.5x11, Surface-Mount - $385.28' },
              { value: '{ "code": "3110", "price": "427.80", "description": "Single Pedestal with Frame, 8.5x11, Deluxe Surface-Mount" }', text: 'Single Pedestal with Frame, 8.5x11, Deluxe Surface-Mount - $427.80' },
              { value: '{ "code": "3111", "price": "606.75", "description": "Double Pedestal with Frame, 18x36, In-Ground" }', text: 'Double Pedestal with Frame, 18x36, In-Ground - $606.75' },
              { value: '{ "code": "3112", "price": "669.75", "description": "Double Pedestal with Frame, 18x36, Surface-Mount" }', text: 'Double Pedestal with Frame, 18x36, Surface-Mount - $669.75' },
              { value: '{ "code": "3113", "price": "750.75", "description": "Double Pedestal with Frame, 18x36, Deluxe Surface-Mount" }', text: 'Double Pedestal with Frame, 18x36, Deluxe Surface-Mount - $750.75' },
              { value: '{ "code": "3114", "price": "644.11", "description": "Double Pedestal with Frame, 24x30, In-Ground" }', text: 'Double Pedestal with Frame, 24x30, In-Ground - $644.11' },
              { value: '{ "code": "3115", "price": "707.10", "description": "Double Pedestal with Frame, 24x30, Surface-Mount" }', text: 'Double Pedestal with Frame, 24x30, Surface-Mount - $707.10' },
              { value: '{ "code": "3116", "price": "788.10", "description": "Double Pedestal with Frame, 24x30, Deluxe Surface-Mount" }', text: 'Double Pedestal with Frame, 24x30, Deluxe Surface-Mount - $788.10' },
              { value: '{ "code": "3117", "price": "588.36", "description": "Double Pedestal with Frame, 24x36, In-Ground" }', text: 'Double Pedestal with Frame, 24x36, In-Ground - $588.36' },
              { value: '{ "code": "3118", "price": "707.10", "description": "Double Pedestal with Frame, 24x36, Surface-Mount" }', text: 'Double Pedestal with Frame, 24x36, Surface-Mount - $707.10' },
              { value: '{ "code": "3119", "price": "688.02", "description": "Double Pedestal with Frame, 24x36, Deluxe Surface-Mount" }', text: 'Double Pedestal with Frame, 24x36, Deluxe Surface-Mount - $688.02' },
              { value: '{ "code": "3120", "price": "714.21", "description": "Double Pedestal with Frame, 24x42, In-Ground" }', text: 'Double Pedestal with Frame, 24x42, In-Ground - $714.21' },
              { value: '{ "code": "3121", "price": "844.43", "description": "Double Pedestal with Frame, 24x42, Surface-Mount" }', text: 'Double Pedestal with Frame, 24x42, Surface-Mount - $844.43' },
              { value: '{ "code": "3122", "price": "874.43", "description": "Double Pedestal with Frame, 24x42, Deluxe Surface-Mount" }', text: 'Double Pedestal with Frame, 24x42, Deluxe Surface-Mount - $874.43' },
              { value: '{ "code": "3123", "price": "252.96", "description": "Single Sleeve with Frame, 18x24" }', text: 'Single Sleeve with Frame, 18x24 - $252.96' },
              { value: '{ "code": "3124", "price": "352.92", "description": "Double Sleeve with Frame, 18x36" }', text: 'Double Sleeve with Frame, 18x36 - $352.92' },
              { value: '{ "code": "3125", "price": "298.79", "description": "Single Sleeve with Frame, 24x24" }', text: 'Single Sleeve with Frame, 24x24 - $298.79' },
              { value: '{ "code": "3126", "price": "392.15", "description": "Double Sleeve with Frame, 24x30" }', text: 'Double Sleeve with Frame, 24x30 - $392.15' },
              { value: '{ "code": "3127", "price": "354.96", "description": "Double Sleeve with Frame, 24x36" }', text: 'Double Sleeve with Frame, 24x36 - $354.96' },
              { value: '{ "code": "3128", "price": "421.52", "description": "Double Sleeve with Frame, 24x42" }', text: 'Double Sleeve with Frame, 24x42 - $421.52' },
              { value: '{ "code": "3129", "price": "481.74", "description": "Double Sleeve with Frame, 24x48" }', text: 'Double Sleeve with Frame, 24x48 - $481.74' },
              { value: '{ "code": "3130", "price": "573.50", "description": "Double Sleeve with Frame, 30x48" }', text: 'Double Sleeve with Frame, 30x48 - $573.50' },
              { value: '{ "code": "3131", "price": "605.01", "description": "Double Sleeve with Frame, 36x48" }', text: 'Double Sleeve with Frame, 36x48 - $605.01' },
              { value: '{ "code": "3132", "price": "768.27", "description": "Double Sleeve with Frame, 48x48" }', text: 'Double Sleeve with Frame, 48x48 - $768.27' },
              { value: '{ "code": "3133", "price": "216.42", "description": "Single Sleeve with Frame, 8.5x11" }', text: 'Single Sleeve with Frame, 8.5x11 - $216.42' }
            ]
          },
          {
            label: 'Wall-mount Frames',
            options: [
              { value: '{ "code": "3134", "price": "245.60", "description": "Wall-mount Frame, 18x24" }', text: 'Wall-mount Frame, 18x24 - $245.60' },
              { value: '{ "code": "3135", "price": "352.92", "description": "Wall-mount Frame, 18x36" }', text: 'Wall-mount Frame, 18x36 - $352.92' },
              { value: '{ "code": "3136", "price": "313.73", "description": "Wall-mount Frame, 24x24" }', text: 'Wall-mount Frame, 24x24 - $313.73' },
              { value: '{ "code": "3137", "price": "392.15", "description": "Wall-mount Frame, 24x30" }', text: 'Wall-mount Frame, 24x30 - $392.15' },
              { value: '{ "code": "3138", "price": "344.63", "description": "Wall-mount Frame, 24x36" }', text: 'Wall-mount Frame, 24x36 - $344.63' },
              { value: '{ "code": "3139", "price": "401.45", "description": "Wall-mount Frame, 24x42" }', text: 'Wall-mount Frame, 24x42 - $401.45' },
              { value: '{ "code": "3140", "price": "481.74", "description": "Wall-mount Frame, 24x48" }', text: 'Wall-mount Frame, 24x48 - $481.74' },
              { value: '{ "code": "3141", "price": "573.50", "description": "Wall-mount Frame, 30x48" }', text: 'Wall-mount Frame, 30x48 - $573.50' },
              { value: '{ "code": "3142", "price": "605.01", "description": "Wall-mount Frame, 36x48" }', text: 'Wall-mount Frame, 36x48 - $605.01' },
              { value: '{ "code": "3143", "price": "768.27", "description": "Wall-mount Frame, 48x48" }', text: 'Wall-mount Frame, 48x48 - $768.27' },
              { value: '{ "code": "3144", "price": "200.12", "description": "Wall-mount Frame, 8.5x11" }', text: 'Wall-mount Frame, 8.5x11 - $200.12' }
            ]
          }
        ],
        mountingStyleQtyDisabled: false,
        graphicPanelOptions: [],
        graphicPanelQtyDisabled: false,
        storywalkPosts: [
          { value: null, text: 'Please select an option' },
          { value: '{ "code": "SW-LPA", "price": "286.17", "description": "Angled Aluminum Post Mount" }', text: 'Angled Aluminum Post Mount - $286.17' },
          { value: '{ "code": "SW-FA", "price": "286.04", "description": "Flush Aluminum Post Mount" }', text: 'Flush Aluminum Post Mount - $286.04' },
          { value: '{ "code": "SW-LPW", "price": "221.32", "description": "Angled Wood Post Mount" }', text: 'Angled Wood Post Mount - $221.32' },
          { value: '{ "code": "SW-FW", "price": "221.32", "description": "Flush Wood Post Mount" }', text: 'Flush Wood Post Mount - $221.32' }
        ],
        storywalkBackers: [
          { value: null, text: 'Please select an option' },
          { value: '{ "code": "none", "price": "0", "description": "No Backer Sheets"}', text: 'No Backer Sheets' },
          { value: '{ "code": "SW-B", "price": "7.95", "description": "Storywalk Backer Sheet - 17.75\\"h x 23.75\\"w x .023\\" thick, semi-rigid polyolefin. Shipping to be added to final invoice."}', text: 'Storywalk Backer Sheets - $7.95 ea.' }
        ],
        storywalkColors: [
          { value: null, text: 'Please select a color' },
          { value: 'Red', text: 'Red' },
          { value: 'Orange', text: 'Orange' },
          { value: 'Harvest Gold', text: 'Harvest Gold' },
          { value: 'Yellow', text: 'Yellow' },
          { value: 'Kelly Green', text: 'Kelly Green' },
          { value: 'Hunter Green', text: 'Hunter Green' },
          { value: 'Azure Blue', text: 'Azure Blue' },
          { value: 'Ocean Blue', text: 'Ocean Blue' },
          { value: 'Royal Blue', text: 'Royal Blue' },
          { value: 'Ivory', text: 'Ivory' },
          { value: 'White', text: 'White' },
          { value: 'Light Grey', text: 'Light Grey' },
          { value: 'Black', text: 'Black' }
        ],
        showMandatoryMessage: false,
        productionSetupValue: '{ "code": "4012", "price": "100", "description": "Mandatory, One-time DuraReader Production Setup" }',
        clientSetupValue: '{ "code": "9001", "price": "75", "description": "Mandatory, One-time Client File Setup" }',
        message: '',
        c_none: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "4018", "price": "28.35", "description": "8.5\\"hx11\\"wx1/8\\" DuraReader" }', text: '8.5"hx11"wx1/8" DuraReader - $28.35' },
            { value: '{ "code": "4000", "price": "61.64", "description": "12\\"hx18\\"wx1/8\\" DuraReader" }', text: '12"hx18"wx1/8" DuraReader - $61.64' },
            { value: '{ "code": "4001", "price": "130.98", "description": "18\\"hx24\\"wx1/8\\" DuraReader" }', text: '18"hx24"wx1/8" DuraReader - $130.98' },
            { value: '{ "code": "4015", "price": "196.48", "description": "18\\"hx36\\"wx1/8\\" DuraReader" }', text: '18"hx36"wx1/8" DuraReader - $196.48' },
            { value: '{ "code": "4014", "price": "174.64", "description": "24\\"hx24\\"wx1/8\\" DuraReader" }', text: '24"hx24"wx1/8" DuraReader - $174.64' },
            { value: '{ "code": "4016", "price": "218.30", "description": "24\\"hx30\\"wx1/8\\" DuraReader" }', text: '24"hx30"wx1/8" DuraReader - $218.30' },
            { value: '{ "code": "4002", "price": "261.96", "description": "24\\"hx36\\"wx1/8\\" DuraReader" }', text: '24"hx36"wx1/8" DuraReader - $261.96' },
            { value: '{ "code": "4003", "price": "305.62", "description": "24\\"hx42\\"wx1/8\\" DuraReader" }', text: '24"hx42"wx1/8" DuraReader - $305.62' },
            { value: '{ "code": "4017", "price": "436.60", "description": "30\\"hx48\\"wx1/8\\" DuraReader" }', text: '30"hx48"wx1/8" DuraReader - $436.60' },
            { value: '{ "code": "4013", "price": "698.55", "description": "48\\"hx48\\"wx1/8\\" DuraReader" }', text: '48"hx48"wx1/8" DuraReader - $698.55' },
            { value: '{ "code": "4005", "price": "150.13", "description": "12\\"hx18\\"wx1/2\\" DuraReader" }', text: '12"hx18"wx1/2" DuraReader - $150.13' },
            { value: '{ "code": "4006", "price": "271.25", "description": "18\\"hx24\\"wx1/2\\" DuraReader" }', text: '18"hx24"wx1/2" DuraReader - $271.25' },
            { value: '{ "code": "4007", "price": "513.50", "description": "24\\"hx36\\"wx1/2\\" DuraReader" }', text: '24"hx36"wx1/2" DuraReader - $513.50' },
            { value: '{ "code": "4008", "price": "542.50", "description": "24\\"hx36\\"wx1/2\\" DuraReader (Requires 2 Mounting Plates)" }', text: '24"hx36"wx1/2" DuraReader (Requires 2 Mounting Plates) - $542.50' },
            { value: '{ "code": "4009", "price": "623.25", "description": "24\\"hx42\\"wx1/2\\" DuraReader (Requires 2 Mounting Plates)" }', text: '24"hx42"wx1/2" DuraReader (Requires 2 Mounting Plates) - $623.25' },
            { value: '{ "code": "4004", "price": "523.91", "description": "36\\"hx48\\"wx1/8\\" DuraReader" }', text: '36"hx48"wx1/8" DuraReader - $523.91' },
            { value: '{ "code": "4004A", "price": "523.91", "description": "48\\"hx36\\"wx1/8\\" DuraReader" }', text: '48"hx36"wx1/8" DuraReader - $523.91' },
            { value: '{ "code": "4010", "price": "1027.01", "description": "36\\"hx48\\"wx1/2\\" DuraReader" }', text: '36"hx48"wx1/2" DuraReader - $1,027.01' },
            { value: '{ "code": "4010A", "price": "1027.01", "description": "48\\"hx36\\"wx1/2\\" DuraReader" }', text: '48"hx36"wx1/2" DuraReader - $1,027.01' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3000: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4005", "price": "150.13", "description": "12\\"hx18\\"wx1/2\\" DuraReader" }', text: '12"hx18"wx1/2" DuraReader - $150.13' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3001: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4006", "price": "271.25", "description": "18\\"hx24\\"wx1/2\\" DuraReader" }', text: '18"hx24"wx1/2" DuraReader - $271.25' },
            { value: '{ "code": "4008", "price": "542.50", "description": "24\\"hx36\\"wx1/2\\" DuraReader (Requires 2 Mounting Plates)" }', text: '24"hx36"wx1/2" DuraReader (Requires 2 Mounting Plates) - $542.50' },
            { value: '{ "code": "4009", "price": "623.25", "description": "24\\"hx42\\"wx1/2\\" DuraReader (Requires 2 Mounting Plates)" }', text: '24"hx42"wx1/2" DuraReader (Requires 2 Mounting Plates) - $623.25' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3002: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4006", "price": "271.25", "description": "18\\"hx24\\"wx1/2\\" DuraReader" }', text: '18"hx24"wx1/2" DuraReader - $271.25' },
            { value: '{ "code": "4007", "price": "513.50", "description": "24\\"hx36\\"wx1/2\\" DuraReader" }', text: '24"hx36"wx1/2" DuraReader - $513.50' },
            { value: '{ "code": "4009", "price": "623.25", "description": "24\\"hx42\\"wx1/2\\" DuraReader (Requires 2 Mounting Plates)" }', text: '24"hx42"wx1/2" DuraReader (Requires 2 Mounting Plates) - $623.25' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3005: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4005", "price": "150.13", "description": "12\\"hx18\\"wx1/2\\" DuraReader" }', text: '12"hx18"wx1/2" DuraReader - $150.13' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3006: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4006", "price": "271.25", "description": "18\\"hx24\\"wx1/2\\" DuraReader" }', text: '18"hx24"wx1/2" DuraReader - $271.25' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3007: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4007", "price": "513.50", "description": "24\\"hx36\\"wx1/2\\" DuraReader" }', text: '24"hx36"wx1/2" DuraReader - $513.50' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3010: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4008", "price": "542.50", "description": "24\\"hx36\\"wx1/2\\" DuraReader" }', text: '24"hx36"wx1/2" DuraReader - $542.50' },
            { value: '{ "code": "4009", "price": "623.25", "description": "24\\"hx42\\"wx1/2\\" DuraReader" }', text: '24"hx42"wx1/2" DuraReader - $623.25' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3021: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4005", "price": "150.13", "description": "12\\"hx18\\"wx1/2\\" DuraReader" }', text: '12"hx18"wx1/2" DuraReader - $150.13' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3022: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4006", "price": "271.25", "description": "18\\"hx24\\"wx1/2\\" DuraReader" }', text: '18"hx24"wx1/2" DuraReader - $271.25' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3023: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4007", "price": "513.50", "description": "24\\"hx36\\"wx1/2\\" DuraReader" }', text: '24"hx36"wx1/2" DuraReader - $513.50' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3026: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4008", "price": "542.50", "description": "24\\"hx36\\"wx1/2\\" DuraReader" }', text: '24"hx36"wx1/2" DuraReader - $542.50' },
            { value: '{ "code": "4009", "price": "623.25", "description": "24\\"hx42\\"wx1/2\\" DuraReader" }', text: '24"hx42"wx1/2" DuraReader - $623.25' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3029: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4007", "price": "513.50", "description": "24\\"hx36\\"wx1/2\\" DuraReader" }', text: '24"hx36"wx1/2" DuraReader - $513.50' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3033: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4007", "price": "513.50", "description": "24\\"hx36\\"wx1/2\\" DuraReader" }', text: '24"hx36"wx1/2" DuraReader - $513.50' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3043: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4010A", "price": "1027.01", "description": "48\\"hx36\\"wx1/2\\" DuraReader" }', text: '48"hx36"wx1/2" DuraReader - $1,027.01' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3043A: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4010A", "price": "1027.01", "description": "48\\"hx36\\"wx1/2\\" DuraReader" }', text: '48"hx36"wx1/2" DuraReader - $1,027.01' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3054: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4005", "price": "150.13", "description": "12\\"hx18\\"wx1/2\\" DuraReader" }', text: '12"hx18"wx1/2" DuraReader - $150.13' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3056: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4005", "price": "150.13", "description": "12\\"hx18\\"wx1/2\\" DuraReader" }', text: '12"hx18"wx1/2" DuraReader - $150.13' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3057: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4006", "price": "271.25", "description": "18\\"hx24\\"wx1/2\\" DuraReader" }', text: '18"hx24"wx1/2" DuraReader - $271.25' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3066: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4002", "price": "261.96", "description": "24\\"hx36\\"wx1/8\\" DuraReader" }', text: '24"hx36"wx1/8" DuraReader - $261.96' },
            { value: '{ "code": "5000", "price": "452.25", "description": "24\\"hx36\\"wx.090\\" Fiberglass Embedded Panel" }', text: '24"hx36"wx.090" Fiberglass Embedded Panel - $452.25' },
            { value: '{ "code": "6000", "price": "1995.50", "description": "24\\"hx36\\"w Porcelain Enamel" }', text: '24"hx36"w Porcelain Enamel - $1995.50' },
            { value: '{ "code": "7000", "price": "258.10", "description": "24\\"hx36\\"w ImageLOC, Single-Sided" }', text: '24"hx36"w ImageLOC, Single-Sided - $258.10' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3067: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4002", "price": "261.96", "description": "24\\"hx36\\"wx1/8\\" DuraReader" }', text: '24"hx36"wx1/8" DuraReader - $261.96' },
            { value: '{ "code": "5000", "price": "452.25", "description": "24\\"hx36\\"wx.090\\" Fiberglass Embedded Panel" }', text: '24"hx36"wx.090" Fiberglass Embedded Panel - $452.25' },
            { value: '{ "code": "6000", "price": "1995.50", "description": "24\\"hx36\\"w Porcelain Enamel" }', text: '24"hx36"w Porcelain Enamel - $1995.50' },
            { value: '{ "code": "7000", "price": "258.10", "description": "24\\"hx36\\"w ImageLOC, Single-Sided" }', text: '24"hx36"w ImageLOC, Single-Sided - $258.10' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3070: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4002", "price": "261.96", "description": "24\\"hx36\\"wx1/8\\" DuraReader" }', text: '24"hx36"wx1/8" DuraReader - $261.96' },
            { value: '{ "code": "5000", "price": "452.25", "description": "24\\"hx36\\"wx.090\\" Fiberglass Embedded Panel" }', text: '24"hx36"wx.090" Fiberglass Embedded Panel - $452.25' },
            { value: '{ "code": "6000", "price": "1995.50", "description": "24\\"hx36\\"w Porcelain Enamel" }', text: '24"hx36"w Porcelain Enamel - $1995.50' },
            { value: '{ "code": "7000", "price": "258.10", "description": "24\\"hx36\\"w ImageLOC, Single-Sided" }', text: '24"hx36"w ImageLOC, Single-Sided - $258.10' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3071: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4002", "price": "261.96", "description": "24\\"hx36\\"wx1/8\\" DuraReader" }', text: '24"hx36"wx1/8" DuraReader - $261.96' },
            { value: '{ "code": "5000", "price": "452.25", "description": "24\\"hx36\\"wx.090\\" Fiberglass Embedded Panel" }', text: '24"hx36"wx.090" Fiberglass Embedded Panel - $452.25' },
            { value: '{ "code": "6000", "price": "1995.50", "description": "24\\"hx36\\"w Porcelain Enamel" }', text: '24"hx36"w Porcelain Enamel - $1995.50' },
            { value: '{ "code": "7000", "price": "258.10", "description": "24\\"hx36\\"w ImageLOC, Single-Sided" }', text: '24"hx36"w ImageLOC, Single-Sided - $258.10' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3072: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4001", "price": "130.98", "description": "18\\"hx24\\"wx1/8\\" DuraReader" }', text: '18"hx24"wx1/8" DuraReader - $130.98' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3073: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4001", "price": "130.98", "description": "18\\"hx24\\"wx1/8\\" DuraReader" }', text: '18"hx24"wx1/8" DuraReader - $130.98' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3076: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4001", "price": "130.98", "description": "18\\"hx24\\"wx1/8\\" DuraReader" }', text: '18"hx24"wx1/8" DuraReader - $130.98' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3077: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4001", "price": "130.98", "description": "18\\"hx24\\"wx1/8\\" DuraReader" }', text: '18"hx24"wx1/8" DuraReader - $130.98' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3084: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4002", "price": "261.96", "description": "24\\"hx36\\"wx1/8\\" DuraReader" }', text: '24"hx36"wx1/8" DuraReader - $261.96' },
            { value: '{ "code": "5000", "price": "452.25", "description": "24\\"hx36\\"wx.090\\" Fiberglass Embedded Panel" }', text: '24"hx36"wx.090" Fiberglass Embedded Panel - $452.25' },
            { value: '{ "code": "6000", "price": "1995.50", "description": "24\\"hx36\\"w Porcelain Enamel" }', text: '24"hx36"w Porcelain Enamel - $1995.50' },
            { value: '{ "code": "7000", "price": "258.10", "description": "24\\"hx36\\"w ImageLOC, Single-Sided" }', text: '24"hx36"w ImageLOC, Single-Sided - $258.10' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3085: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4002", "price": "261.96", "description": "24\\"hx36\\"wx1/2\\" DuraReader" }', text: '24"hx36"wx1/2" DuraReader - $261.96' },
            { value: '{ "code": "5000", "price": "452.25", "description": "24\\"hx36\\"wx.090\\" Fiberglass Embedded Panel" }', text: '24"hx36"wx.090" Fiberglass Embedded Panel - $452.25' },
            { value: '{ "code": "6000", "price": "1995.50", "description": "24\\"hx36\\"w Porcelain Enamel" }', text: '24"hx36"w Porcelain Enamel - $1995.50' },
            { value: '{ "code": "7000", "price": "258.10", "description": "24\\"hx36\\"w ImageLOC, Single-Sided" }', text: '24"hx36"w ImageLOC, Single-Sided - $258.10' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3086: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4004", "price": "523.91", "description": "36\\"hx48\\"wx1/8\\" DuraReader" }', text: '36"hx48"wx1/8" DuraReader - $523.91' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3087: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4004", "price": "523.91", "description": "36\\"hx48\\"wx1/8\\" DuraReader" }', text: '36"hx48"wx1/8" DuraReader - $523.91' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3088: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4013", "price": "698.55", "description": "48\\"hx48\\"wx1/8\\" DuraReader" }', text: '48"hx48"wx1/8" DuraReader - $698.55' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3089: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4002", "price": "261.96", "description": "24\\"hx36\\"wx1/2\\" DuraReader" }', text: '24"hx36"wx1/2" DuraReader - $261.96' },
            { value: '{ "code": "5000", "price": "452.25", "description": "24\\"hx36\\"wx.090\\" Fiberglass Embedded Panel" }', text: '24"hx36"wx.090" Fiberglass Embedded Panel - $452.25' },
            { value: '{ "code": "6000", "price": "1995.50", "description": "24\\"hx36\\"w Porcelain Enamel" }', text: '24"hx36"w Porcelain Enamel - $1995.50' },
            { value: '{ "code": "7000", "price": "258.10", "description": "24\\"hx36\\"w ImageLOC, Single-Sided" }', text: '24"hx36"w ImageLOC, Single-Sided - $258.10' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3090: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4002", "price": "261.96", "description": "24\\"hx36\\"wx1/2\\" DuraReader" }', text: '24"hx36"wx1/2" DuraReader - $261.96' },
            { value: '{ "code": "5000", "price": "452.25", "description": "24\\"hx36\\"wx.090\\" Fiberglass Embedded Panel" }', text: '24"hx36"wx.090" Fiberglass Embedded Panel - $452.25' },
            { value: '{ "code": "6000", "price": "1995.50", "description": "24\\"hx36\\"w Porcelain Enamel" }', text: '24"hx36"w Porcelain Enamel - $1995.50' },
            { value: '{ "code": "7000", "price": "258.10", "description": "24\\"hx36\\"w ImageLOC, Single-Sided" }', text: '24"hx36"w ImageLOC, Single-Sided - $258.10' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3091: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4004", "price": "523.91", "description": "36\\"hx48\\"wx1/2\\" DuraReader" }', text: '36"hx48"wx1/2" DuraReader - $523.91' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3092: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4004", "price": "523.91", "description": "36\\"hx48\\"wx1/2\\" DuraReader" }', text: '36"hx48"wx1/2" DuraReader - $523.91' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3093: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4013", "price": "698.55", "description": "48\\"hx48\\"wx1/8\\" DuraReader" }', text: '48"hx48"wx1/8" DuraReader - $698.55' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3094: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4002", "price": "261.96", "description": "24\\"hx36\\"wx1/8\\" DuraReader" }', text: '24"hx36"wx1/8" DuraReader - $261.96' },
            { value: '{ "code": "5000", "price": "452.25", "description": "24\\"hx36\\"wx.090\\" Fiberglass Embedded Panel" }', text: '24"hx36"wx.090" Fiberglass Embedded Panel - $452.25' },
            { value: '{ "code": "6000", "price": "1995.50", "description": "24\\"hx36\\"w Porcelain Enamel" }', text: '24"hx36"w Porcelain Enamel - $1995.50' },
            { value: '{ "code": "7000", "price": "258.10", "description": "24\\"hx36\\"w ImageLOC, Single-Sided" }', text: '24"hx36"w ImageLOC, Single-Sided - $258.10' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3095: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4002", "price": "261.96", "description": "24\\"hx36\\"wx1/8\\" DuraReader" }', text: '24"hx36"wx1/8" DuraReader - $261.96' },
            { value: '{ "code": "5000", "price": "452.25", "description": "24\\"hx36\\"wx.090\\" Fiberglass Embedded Panel" }', text: '24"hx36"wx.090" Fiberglass Embedded Panel - $452.25' },
            { value: '{ "code": "6000", "price": "1995.50", "description": "24\\"hx36\\"w Porcelain Enamel" }', text: '24"hx36"w Porcelain Enamel - $1995.50' },
            { value: '{ "code": "7000", "price": "258.10", "description": "24\\"hx36\\"w ImageLOC, Single-Sided" }', text: '24"hx36"w ImageLOC, Single-Sided - $258.10' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3096: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4004", "price": "523.91", "description": "36\\"hx48\\"wx1/8\\" DuraReader" }', text: '36"hx48"wx1/8" DuraReader - $523.91' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3097: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4004", "price": "523.91", "description": "36\\"hx48\\"wx1/8\\" DuraReader" }', text: '36"hx48"wx1/8" DuraReader - $523.91' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3098: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4013", "price": "698.55", "description": "48\\"hx48\\"wx1/8\\" DuraReader" }', text: '48"hx48"wx1/8" DuraReader - $698.55' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3099: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4001", "price": "130.98", "description": "18\\"hx24\\"wx1/8\\" DuraReader" }', text: '18"hx24"wx1/8" DuraReader - $130.98' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3100: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4001", "price": "130.98", "description": "18\\"hx24\\"wx1/2\\" DuraReader" }', text: '18"hx24"wx1/2" DuraReader - $130.98' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3101: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4001", "price": "130.98", "description": "18\\"hx24\\"wx1/8\\" DuraReader" }', text: '18"hx24"wx1/8" DuraReader - $130.98' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3102: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4014", "price": "174.64", "description": "24\\"hx24\\"wx1/8\\" DuraReader" }', text: '24"hx24"wx1/8" DuraReader - $174.64' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3103: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4014", "price": "174.64", "description": "24\\"hx24\\"wx1/8\\" DuraReader" }', text: '24"hx24"wx1/8" DuraReader - $174.64' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3104: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4014", "price": "174.64", "description": "24\\"hx24\\"wx1/8\\" DuraReader" }', text: '24"hx24"wx1/8" DuraReader - $174.64' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3105: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4002", "price": "261.96", "description": "24\\"hx36\\"wx1/8\\" DuraReader" }', text: '24"hx36"wx1/8" DuraReader - $261.96' },
            { value: '{ "code": "5000", "price": "452.25", "description": "24\\"hx36\\"wx.090\\" Fiberglass Embedded Panel" }', text: '24"hx36"wx.090" Fiberglass Embedded Panel - $452.25' },
            { value: '{ "code": "6000", "price": "1995.50", "description": "24\\"hx36\\"w Porcelain Enamel" }', text: '24"hx36"w Porcelain Enamel - $1995.50' },
            { value: '{ "code": "7000", "price": "258.10", "description": "24\\"hx36\\"w ImageLOC, Single-Sided" }', text: '24"hx36"w ImageLOC, Single-Sided - $258.10' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3106: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4002", "price": "261.96", "description": "24\\"hx36\\"wx1/8\\" DuraReader" }', text: '24"hx36"wx1/8" DuraReader - $261.96' },
            { value: '{ "code": "5000", "price": "452.25", "description": "24\\"hx36\\"wx.090\\" Fiberglass Embedded Panel" }', text: '24"hx36"wx.090" Fiberglass Embedded Panel - $452.25' },
            { value: '{ "code": "6000", "price": "1995.50", "description": "24\\"hx36\\"w Porcelain Enamel" }', text: '24"hx36"w Porcelain Enamel - $1995.50' },
            { value: '{ "code": "7000", "price": "258.10", "description": "24\\"hx36\\"w ImageLOC, Single-Sided" }', text: '24"hx36"w ImageLOC, Single-Sided - $258.10' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3107: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4002", "price": "261.96", "description": "24\\"hx36\\"wx1/8\\" DuraReader" }', text: '24"hx36"wx1/8" DuraReader - $261.96' },
            { value: '{ "code": "5000", "price": "452.25", "description": "24\\"hx36\\"wx.090\\" Fiberglass Embedded Panel" }', text: '24"hx36"wx.090" Fiberglass Embedded Panel - $452.25' },
            { value: '{ "code": "6000", "price": "1995.50", "description": "24\\"hx36\\"w Porcelain Enamel" }', text: '24"hx36"w Porcelain Enamel - $1995.50' },
            { value: '{ "code": "7000", "price": "258.10", "description": "24\\"hx36\\"w ImageLOC, Single-Sided" }', text: '24"hx36"w ImageLOC, Single-Sided - $258.10' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3108: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4018", "price": "28.35", "description": "8.5\\"hx11\\"wx1/8\\" DuraReader" }', text: '8.5"hx11"wx1/8" DuraReader - $28.35' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3109: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4018", "price": "28.35", "description": "8.5\\"hx11\\"wx1/8\\" DuraReader" }', text: '8.5"hx11"wx1/8" DuraReader - $28.35' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3110: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4018", "price": "28.35", "description": "8.5\\"hx11\\"wx1/8\\" DuraReader" }', text: '8.5"hx11"wx1/8" DuraReader - $28.35' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3111: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4015", "price": "196.48", "description": "18\\"hx36\\"wx1/8\\" DuraReader" }', text: '18"hx36"wx1/8" DuraReader - $196.48' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3112: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4015", "price": "196.48", "description": "18\\"hx36\\"wx1/8\\" DuraReader" }', text: '18"hx36"wx1/8" DuraReader - $196.48' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3113: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4015", "price": "196.48", "description": "18\\"hx36\\"wx1/8\\" DuraReader" }', text: '18"hx36"wx1/8" DuraReader - $196.48' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3114: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4016", "price": "218.30", "description": "24\\"hx30\\"wx1/8\\" DuraReader" }', text: '24"hx30"wx1/8" DuraReader - $218.30' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3115: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4016", "price": "218.30", "description": "24\\"hx30\\"wx1/8\\" DuraReader" }', text: '24"hx30"wx1/8" DuraReader - $218.30' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3116: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4016", "price": "218.30", "description": "24\\"hx30\\"wx1/8\\" DuraReader" }', text: '24"hx30"wx1/8" DuraReader - $218.30' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3117: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4002", "price": "261.96", "description": "24\\"hx36\\"wx1/8\\" DuraReader" }', text: '24"hx36"wx1/8" DuraReader - $261.96' },
            { value: '{ "code": "5000", "price": "452.25", "description": "24\\"hx36\\"wx.090\\" Fiberglass Embedded Panel" }', text: '24"hx36"wx.090" Fiberglass Embedded Panel - $452.25' },
            { value: '{ "code": "6000", "price": "1995.50", "description": "24\\"hx36\\"w Porcelain Enamel" }', text: '24"hx36"w Porcelain Enamel - $1995.50' },
            { value: '{ "code": "7000", "price": "258.10", "description": "24\\"hx36\\"w ImageLOC, Single-Sided" }', text: '24"hx36"w ImageLOC, Single-Sided - $258.10' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3118: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4002", "price": "261.96", "description": "24\\"hx36\\"wx1/8\\" DuraReader" }', text: '24"hx36"wx1/8" DuraReader - $261.96' },
            { value: '{ "code": "5000", "price": "452.25", "description": "24\\"hx36\\"wx.090\\" Fiberglass Embedded Panel" }', text: '24"hx36"wx.090" Fiberglass Embedded Panel - $452.25' },
            { value: '{ "code": "6000", "price": "1995.50", "description": "24\\"hx36\\"w Porcelain Enamel" }', text: '24"hx36"w Porcelain Enamel - $1995.50' },
            { value: '{ "code": "7000", "price": "258.10", "description": "24\\"hx36\\"w ImageLOC, Single-Sided" }', text: '24"hx36"w ImageLOC, Single-Sided - $258.10' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3119: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4002", "price": "261.96", "description": "24\\"hx36\\"wx1/8\\" DuraReader" }', text: '24"hx36"wx1/8" DuraReader - $261.96' },
            { value: '{ "code": "5000", "price": "452.25", "description": "24\\"hx36\\"wx.090\\" Fiberglass Embedded Panel" }', text: '24"hx36"wx.090" Fiberglass Embedded Panel - $452.25' },
            { value: '{ "code": "6000", "price": "1995.50", "description": "24\\"hx36\\"w Porcelain Enamel" }', text: '24"hx36"w Porcelain Enamel - $1995.50' },
            { value: '{ "code": "7000", "price": "258.10", "description": "24\\"hx36\\"w ImageLOC, Single-Sided" }', text: '24"hx36"w ImageLOC, Single-Sided - $258.10' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3120: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4003", "price": "305.62", "description": "24\\"hx42\\"wx1/8\\" DuraReader" }', text: '24"hx42"wx1/8" DuraReader - $305.62' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3121: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4003", "price": "305.62", "description": "24\\"hx42\\"wx1/8\\" DuraReader" }', text: '24"hx42"wx1/8" DuraReader - $305.62' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3122: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4003", "price": "305.62", "description": "24\\"hx42\\"wx1/8\\" DuraReader" }', text: '24"hx42"wx1/8" DuraReader - $305.62' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3123: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4001", "price": "130.98", "description": "18\\"hx24\\"wx1/8\\" DuraReader" }', text: '18"hx24"wx1/8" DuraReader - $130.98' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3124: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4015", "price": "196.48", "description": "18\\"hx36\\"wx1/8\\" DuraReader" }', text: '18"hx36"wx1/8" DuraReader - $196.48' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3125: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4014", "price": "174.64", "description": "24\\"hx24\\"wx1/8\\" DuraReader" }', text: '24"hx24"wx1/8" DuraReader - $174.64' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3126: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4016", "price": "218.30", "description": "24\\"hx30\\"wx1/8\\" DuraReader" }', text: '24"hx30"wx1/8" DuraReader - $218.30' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3127: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4002", "price": "261.96", "description": "24\\"hx36\\"wx1/8\\" DuraReader" }', text: '24"hx36"wx1/8" DuraReader - $261.96' },
            { value: '{ "code": "5000", "price": "452.25", "description": "24\\"hx36\\"wx.090\\" Fiberglass Embedded Panel" }', text: '24"hx36"wx.090" Fiberglass Embedded Panel - $452.25' },
            { value: '{ "code": "6000", "price": "1995.50", "description": "24\\"hx36\\"w Porcelain Enamel" }', text: '24"hx36"w Porcelain Enamel - $1995.50' },
            { value: '{ "code": "7000", "price": "258.10", "description": "24\\"hx36\\"w ImageLOC, Single-Sided" }', text: '24"hx36"w ImageLOC, Single-Sided - $258.10' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3128: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4003", "price": "305.62", "description": "24\\"hx42\\"wx1/8\\" DuraReader" }', text: '24"hx42"wx1/8" DuraReader - $305.62' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3129: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3130: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4017", "price": "436.60", "description": "30\\"hx48\\"wx1/8\\" DuraReader" }', text: '30"hx48"wx1/8" DuraReader - $436.60' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3131: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4004", "price": "523.91", "description": "36\\"hx48\\"wx1/2\\" DuraReader" }', text: '36"hx48"wx1/2" DuraReader - $523.91' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3132: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4013", "price": "698.55", "description": "48\\"hx48\\"wx1/8\\" DuraReader" }', text: '48"hx48"wx1/8" DuraReader - $698.55' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3133: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4018", "price": "28.35", "description": "8.5\\"hx11\\"wx1/8\\" DuraReader" }', text: '8.5"hx11"wx1/8" DuraReader - $28.35' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3134: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4001", "price": "130.98", "description": "18\\"hx24\\"wx1/8\\" DuraReader" }', text: '18"hx24"wx1/8" DuraReader - $130.98' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3135: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4015", "price": "196.48", "description": "18\\"hx36\\"wx1/8\\" DuraReader" }', text: '18"hx36"wx1/8" DuraReader - $196.48' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3136: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4014", "price": "174.64", "description": "24\\"hx24\\"wx1/8\\" DuraReader" }', text: '24"hx24"wx1/8" DuraReader - $174.64' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3137: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4016", "price": "218.30", "description": "24\\"hx30\\"wx1/8\\" DuraReader" }', text: '24"hx30"wx1/8" DuraReader - $218.30' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3138: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4002", "price": "261.96", "description": "24\\"hx36\\"wx1/8\\" DuraReader" }', text: '24"hx36"wx1/8" DuraReader - $261.96' },
            { value: '{ "code": "5000", "price": "452.25", "description": "24\\"hx36\\"wx.090\\" Fiberglass Embedded Panel" }', text: '24"hx36"wx.090" Fiberglass Embedded Panel - $452.25' },
            { value: '{ "code": "6000", "price": "1995.50", "description": "24\\"hx36\\"w Porcelain Enamel" }', text: '24"hx36"w Porcelain Enamel - $1995.50' },
            { value: '{ "code": "7000", "price": "258.10", "description": "24\\"hx36\\"w ImageLOC, Single-Sided" }', text: '24"hx36"w ImageLOC, Single-Sided - $258.10' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3139: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4003", "price": "305.62", "description": "24\\"hx42\\"wx1/8\\" DuraReader" }', text: '24"hx42"wx1/8" DuraReader - $305.62' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3140: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3141: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4017", "price": "436.60", "description": "30\\"hx48\\"wx1/8\\" DuraReader" }', text: '30"hx48"wx1/8" DuraReader - $436.60' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3142: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4004", "price": "523.91", "description": "36\\"hx48\\"wx1/8\\" DuraReader" }', text: '36"hx48"wx1/8" DuraReader - $523.91' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3143: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4013", "price": "698.55", "description": "48\\"hx48\\"wx1/8\\" DuraReader" }', text: '48"hx48"wx1/8" DuraReader - $698.55' }
          ],
          designProofOptions: this.designProofOptions
        },
        c_3144: {
          graphicPanelOptions: [
            { value: null, text: 'Please select an option' },
            { value: '{ "code": "NA", "price": "0.00" }', text: 'No Graphic Panel' },
            { value: '{ "code": "4018", "price": "28.35", "description": "8.5\\"hx11\\"wx1/8\\" DuraReader" }', text: '8.5"hx11"wx1/8" DuraReader - $28.35' }
          ],
          designProofOptions: this.designProofOptions
        }
      }
    },
    computed: {
      artworkDisabled () {
        if (this.formGraphicShow) {
          return !this.form.graphicPanel || !this.form.mountingStyle
        }

        if (this.formNovalloyShow) {
          return !this.form.novalloyMounting
        }
      },
      amenityImg () {
        return JSON.parse(this.form.amenityOption).img
      },
      amenityOptions () {
        if (!this.form.amenityType) {
          return [{ value: null, text: 'Please select an option' }]
        }

        const data = this[`amenity${this.form.amenityCategory[0].toUpperCase()}${this.form.amenityCategory.substring(1)}`]

        const type = data.find(type => {
          return type.label === this.form.amenityType
        })

        return [{ value: null, text: 'Please select an option' }, ...type.options]
      },
      amenityTypes () {
        if (!this.form.amenityCategory) {
          return [{ value: null, text: 'Please select an option' }]
        }

        const data = this[`amenity${this.form.amenityCategory[0].toUpperCase()}${this.form.amenityCategory.substring(1)}`]

        // Create list of only "labels"
        const types = data.filter(type => {
          return !!type.label
        }).map(type => {
          return { value: type.label, text: type.label }
        })

        return [{ value: null, text: 'Please select an option' }, ...types]
      },
      novalloyMountingOptions () {
        if (!this.form.novalloyGraphic) {
          return [{ value: null, text: 'Please select an option' }]
        }

        const graphic = JSON.parse(this.form.novalloyGraphic)

        return this.novalloyMounting.filter(option => {
          if (!option.value) {
            return true
          }
          const value = JSON.parse(option.value)
          return !value.mount || (value.mount === graphic.mount)
        })
      },
      uri () {
        return window.location.href.substring(0, window.location.href.lastIndexOf('/'))
      },
      noGraphicPanel () {
        if (JSON.parse(this.form.graphicPanel)) {
          return JSON.parse(this.form.graphicPanel).code === 'NA'
        }
        return false
      },
      designOptions () {
        return this.designProofOptions.filter(option => {
          if (!option.type || option.type === this.designOption) {
            return option
          }
        })
      },
      fullForm () {
        return true
        // TODO disable if the form is not complete
        /*
        return (this.form.mountingStyle && this.form.graphicPanel && JSON.parse(this.form.graphicPanel).code === 'NA') || (
          (this.form.mountingStyle && this.form.graphicPanel) && (
            this.form.illustration ||
            this.form.colorSample ||
            this.form.textWriting ||
            this.form.clientFileSetup ||
            this.form.layoutDesign ||
            this.form.layoutProof
          )
        )
         */
      },
      shippingCost () {
        if (this.formNovalloyShow) {
          if (this.form.novalloyGraphic && this.form.novalloyMounting) {
            return `Estimated shipping costs: <span style="font-size: larger; font-weight: bold; margin-left: 10px;">$${this.shipping}</span>`
          }
        }

        if (this.formAmenitiesShow) {
          if (this.form.amenityOption) {
            return `Estimated shipping costs: <span style="font-size: larger; font-weight: bold; margin-left: 10px;">$${this.shipping}</span>`
          }
        }

        if (this.formGraphicShow) {
          if (this.form.mountingStyle && this.form.graphicPanel) {
            return `Estimated shipping costs: <span style="font-size: larger; font-weight: bold; margin-left: 10px;">$${this.shipping}</span>`
          }
        }

        return 'Calculating...'
      },
      subtotal () {
        let subtotal = 0
        if (this.formAmenitiesShow && this.form.amenityOption) {
          subtotal += (parseFloat(JSON.parse(this.form.amenityOption).price) * parseInt(this.form.amenityQty))
          this.shipping = (subtotal * 0.18).toFixed(2)
        }

        if (this.formNovalloyShow && this.form.novalloyGraphic) {
          subtotal += (parseFloat(JSON.parse(this.form.novalloyGraphic).price) * parseInt(this.form.novalloyGraphicQty))

          if (this.form.novalloyMounting) {
            subtotal += (parseFloat(JSON.parse(this.form.novalloyMounting).price) * parseInt(this.form.novalloyMountingQty))
          }

          this.shipping = (subtotal * 0.18).toFixed(2)

          if (this.form.clientFileSetup) {
            subtotal += parseFloat(JSON.parse(this.form.clientFileSetup).price)
          }
          if (this.form.illustration) {
            subtotal += (parseFloat(JSON.parse(this.form.illustration).price) * parseInt(this.form.novalloyGraphicQty))
          }
          if (this.form.layoutDesign) {
            subtotal += (parseFloat(JSON.parse(this.form.layoutDesign).price) * parseInt(this.form.novalloyGraphicQty))
          }
          if (this.form.textWriting) {
            subtotal += (parseFloat(JSON.parse(this.form.textWriting).price) * parseInt(this.form.novalloyGraphicQty))
          }
          if (this.form.layoutProof) {
            subtotal += parseFloat(JSON.parse(this.form.layoutProof).price)
          }
        }

        if (this.formGraphicShow) {
          if (this.form.mountingStyle) {
            subtotal += (parseFloat(JSON.parse(this.form.mountingStyle).price) * parseInt(this.form.mountingStyleQty))
            if (this.form.graphicPanel) {
              subtotal += (parseFloat(JSON.parse(this.form.graphicPanel).price) * parseInt(this.form.graphicPanelQty))

              this.shipping = (subtotal * 0.18).toFixed(2)

              if (this.form.clientFileSetup) {
                subtotal += parseFloat(JSON.parse(this.form.clientFileSetup).price)
              }
              if (this.form.illustration) {
                subtotal += (parseFloat(JSON.parse(this.form.illustration).price) * parseInt(this.form.graphicPanelQty))
              }
              if (this.form.layoutDesign) {
                subtotal += (parseFloat(JSON.parse(this.form.layoutDesign).price) * parseInt(this.form.graphicPanelQty))
              }
              if (this.form.textWriting) {
                subtotal += (parseFloat(JSON.parse(this.form.textWriting).price) * parseInt(this.form.graphicPanelQty))
              }
              if (this.form.layoutProof) {
                subtotal += parseFloat(JSON.parse(this.form.layoutProof).price)
              }
              if (this.form.colorSample) {
                subtotal += parseFloat(JSON.parse(this.form.colorSample).price)
              }

              if (this.showMandatoryMessage) {
                subtotal += 100
              }
              if (this.designOption === 'ready' && this.form.graphicPanel && this.form.mountingStyle) {
                subtotal += 75
              }

              // show subtotal with added shipping
              subtotal += parseFloat(this.shipping)
            }
          }
        }

        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(subtotal)
      }
    },
    created () {
      this.designProofOptions = [
        { value: '{ "code": "9001", "price": "75.00", "description": "Client File Setup" }', text: 'Client File Setup - $75.00', type: 'ready' },
        { value: '{ "code": "9000", "price": "400.00", "description": "Layout Design" }', text: 'Layout Design - $400.00', type: 'help' },
        { value: '{ "code": "9005", "price": "800.00", "description": "Illustration" }', text: 'Illustration - $800.00', type: 'help' },
        { value: '{ "code": "9006", "price": "600.00", "description": "Text Writing" }', text: 'Text Writing - $600.00', type: 'help' },
        { value: '{ "code": "9004", "price": "0.00", "description": "Layout Proof" }', text: 'Layout Proof - $0.00' },
        { value: '{ "code": "9003", "price": "75.00", "description": "Color Sample" }', text: 'Color Sample - $75.00' }
      ]
    },
    mounted () {
      if (this.$route.query.s && (this.$route.query.s === 't' || this.$route.query.s === 'f')) {
        // Do not show pre email form
        this.preformShow = false
        // Do not show form options
        this.chooseForm = false
        // Do not show graphic panel form
        this.formGraphicShow = false

        if (this.$route.query.s === 't') { // success = true
          this.message = 'Estimate submitted successfully!'
          this.downloadLink = `${this.uri}/storage/quotes/${this.$route.query.pdf}`
          this.showDownload = true
        } else if (this.$route.query.s === 'f') {
          this.message = 'An error occurred. Please try again.'
        }
        // Remove query to allow expected refresh result
        this.$router.replace({path: '/estimate'})
      }

      let recaptchaScript = document.createElement('script')
      recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js')
      document.head.appendChild(recaptchaScript)
    },
    watch: {
      chooseForm (val) {
        // Send GA event
        if (val === true && this.$ga) {
          this.$gtag.event('estimate_choose_form', {
            'event_category': 'estimate',
            'event_label': 'choose_form',
            'value': 2
          })
        }
      },
      formGraphicShow (val) {
        // Send GA event
        if (val === true && this.$ga) {
          this.$gtag.event('estimate_graphic_panel_form', {
            'event_category': 'estimate',
            'event_label': 'graphic_panel_form',
            'value': 2
          })
        }
      },
      formNovalloyShow (val) {
        // Send GA event
        if (val === true && this.$ga) {
          this.$gtag.event('estimate_novalloy_panels_form', {
            'event_category': 'estimate',
            'event_label': 'novalloy_panels_form',
            'value': 2
          })
        }
      },
      formAmenitiesShow (val) {
        // Send GA event
        if (val === true && this.$ga) {
          this.$gtag.event('estimate_amenities_form', {
            'event_category': 'estimate',
            'event_label': 'amenities_form',
            'value': 2
          })
        }
      },
      formStorywalkShow (val) {
        // Send GA event
        if (val === true && this.$ga) {
          this.$gtag.event('estimate_story-walk_form', {
            'event_category': 'estimate',
            'event_label': 'story-walk_form',
            'value': 2
          })
        }
      }
    },
    methods: {
      downloadClicked () {
        // Send GA event
        if (this.$ga) {
          this.$gtag.event('estimate_download', {
            'event_category': 'estimate',
            'event_label': 'download',
            'value': 4
          })
        }
      },
      resetForm () {
        this.showDownload = false
        this.thankYouMessage = false
        this.message = ''
        this.chooseForm = true

        // amenities
        this.formAmenitiesShow = false
        this.amenityImages = []
        this.form.amenityCategory = null
        this.form.amenityType = null
        this.form.amenityOption = null
        this.form.amenityQty = 1

        // graphic panel
        this.formGraphicShow = false
        this.form.mountingStyle = null
        this.form.mountingStyleQty = 1
        this.form.graphicPanel = null
        this.form.graphicPanelQty = 1
        this.form.colorSample = null
        this.form.layoutProof = null
        this.form.illustration = null
        this.form.textWriting = null
        this.designOption = ''

        // novalloy
        this.formNovalloyShow = false
        this.form.novalloyGraphic = null
        this.form.novalloyGraphicQty = 1
        this.form.novalloyMounting = null
        this.form.novalloyMountingQty = 1
        this.novalloyMountingQtyDisabled = false

        // storywalk
        this.formStorywalkShow = false
        this.form.storywalkPost = null
        this.form.storywalkPostQty = 16

        // Send GA event
        if (this.$ga) {
          this.$gtag.event('estimate_reset', {
            'event_category': 'user',
            'event_label': 'estimate',
            'value': 2
          })
        }
      },
      showThumb (num) {
        this.thumb = {
          show: true,
          num: num
        }
      },
      hideThumb () {
        this.thumb = {
          show: false,
          num: null
        }
      },
      validateBackerQty (e) {
        const val = e.target.value
        if (val < 1 || val > 2) {
          this.form[e.target.name] = 1
        }
      },
      validateQty (e) {
        const val = e.target.value
        if (val <= 0 || /[-]|[.]/.test(val)) {
          this.form[e.target.name] = 1
        }
        // storywalk must be between 16 and 24
        if (this.formStorywalkShow) {
          if (val < 16) {
            this.form[e.target.name] = 16
          }
          if (val > 24) {
            this.form[e.target.name] = 24
          }
        }
      },
      updateAmenityCategory (e) {
        this.form.amenityType = null
        this.form.amenityOption = null
        this.form.amenityQty = 1

        this.form.amenityCategory = e
      },
      updateAmenityType (e) {
        this.form.amenityOption = null
        this.form.amenityQty = 1

        this.form.amenityType = e

        this.updateAmenityImages()
      },
      updateAmenityImages () {
        // must create new array or amenityOptions gets messed
        const options = [...this.amenityOptions].splice(1)
        const images = options.map(item => {
          return { img: JSON.parse(item.value).img, title: JSON.parse(item.value).description }
        })
        // Set images to show
        this.amenityImages = images
      },
      updateAmenityOptions (e) {
        if (!e) {
          this.form.amenityOption = null
          this.form.amenityQty = 1
        }

        this.form.amenityOption = e
      },
      updateNovalloyGraphic (e) {
        if (!e) {
          this.form.novalloyGraphicQty = 1
          this.form.novalloyMountingQty = 1
          this.form.novalloyMounting = null
          this.form.novalloyGraphic = null
          this.designOption = null
          this.form.layoutDesign = false
          this.form.illustration = false
          this.form.colorSample = false
          this.form.layoutProof = false
          this.form.textWriting = false
          return
        }

        this.form.novalloyGraphic = e
      },
      updateNovalloyMounting (e) {
        const option = JSON.parse(e)

        this.novalloyMountingQtyDisabled = false

        if (!e) {
          this.form.novalloyMounting = e
          this.form.novalloyMountingQty = 1
          this.designOption = null
          this.form.layoutDesign = false
          this.form.illustration = false
          this.form.colorSample = false
          this.form.layoutProof = false
          this.form.textWriting = false
        }

        if (option && option.code === 'none') {
          this.form.novalloyMountingQty = 1
          this.novalloyMountingQtyDisabled = true
        }

        this.form.novalloyMounting = e
      },
      updateMountingStyle (e) {
        if (!e) {
          this.form.mountingStyle = e
          this.form.graphicPanel = e
          this.designOption = null
          this.form.layoutDesign = false
          this.form.illustration = false
          this.form.colorSample = false
          this.form.layoutProof = false
          this.form.textWriting = false
          this.form.clientFileSetup = false
          this.form.mountingStyleQty = 1
          this.form.graphicPanelQty = 1
          return
        }

        this.form.mountingStyle = e
        this.form.graphicPanel = null
        this.form.designProof = []
        this.selectedTree = this[`c_${JSON.parse(e).code}`]

        // disable mounting qty if none mounting
        if (JSON.parse(e).code === 'none') {
          this.form.mountingStyleQty = 0
          this.mountingStyleQtyDisabled = true
        } else {
          this.form.mountingStyleQty = 1
          this.mountingStyleQtyDisabled = false
        }
      },
      updateGraphicPanel (e) {
        this.form.graphicPanel = e
        this.graphicPanelQtyDisabled = false
        this.showMandatoryMessage = false

        if (this.form.graphicPanelQty === 0) {
          this.form.graphicPanelQty = 1
        }

        if (!e) {
          this.designOption = null
          this.form.layoutDesign = false
          this.form.illustration = false
          this.form.colorSample = false
          this.form.layoutProof = false
          this.form.textWriting = false
          this.form.clientFileSetup = false
          this.form.graphicPanelQty = 1
          return
        }

        // disable panel qty if manual setup fee
        // if (JSON.parse(e).code === '4012') {
        //   this.form.graphicPanelQty = 1
        //   this.graphicPanelQtyDisabled = true
        //   return
        // }
        if (JSON.parse(e).code === 'NA') {
          this.designOption = null
          this.form.layoutDesign = false
          this.form.illustration = false
          this.form.colorSample = false
          this.form.layoutProof = false
          this.form.textWriting = false
          this.form.clientFileSetup = false
          this.form.graphicPanelQty = 0
          this.graphicPanelQtyDisabled = true
          return
        }

        this.showMandatoryMessage = !!JSON.parse(e).description.includes('DuraReader')
      },
      updateDesignProof (e) {
        this.form.designProof = []
      },
      updateStorywalkPost (e) {
        this.form.storywalkPost = e
      },
      updateStorywalkBackers (e) {
        // set backers
        this.form.storywalkBackers = e
        this.form.storywalkBackersQty = 1

        if (e) {
          if (JSON.parse(e).code === 'none') {
            this.form.storywalkBackersQty = 0
            this.form.storywalkColors = null
          }
        } else {
          // none selected
          this.form.storywalkBackersQty = 0
          this.form.storywalkColors = null
        }
      },
      updateStorywalkColors (e) {
        this.form.storywalkColors = e
      },
      processPreForm () {
        const recpatchaValue = document.getElementsByClassName('g-recaptcha-response')[0].value
        if (!recpatchaValue) {
          this.message = 'Please enter a valid email address to create an estimate.'
          return
        }

        // Validate email
        const emailReg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
        if (!emailReg.test(this.preform.preformEmail)) {
          this.message = 'Please enter a valid email address to create an estimate.'
          // Send GA event
          if (this.$ga) {
            this.$gtag.event('estimate_validation_error', {
              'event_category': 'validation',
              'event_label': 'email',
              'value': 0
            })
          }
          return
        }

        if (!this.preform.preformHow) {
          this.message = "Please let us know how you've heard from us."
          return
        }

        if (this.preform.preformHow === 'Other' && !this.preform.preformOther) {
          this.message = "Please let us know how you've heard from us."
          return
        }

        this.preform.recaptcha = recpatchaValue

        axios.post(
          `${this.uri}/static/xero/estimateEmail.php`,
          JSON.stringify(this.preform),
          {
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          }
        )
          .then((res) => {
            if (res.data.code === 200) {
              // clear any error message
              this.message = ''
              // hide pre form
              this.preformShow = false
              // show estimate type buttons
              this.chooseForm = true
              // Send GA event
              if (this.$ga) {
                this.$gtag.event('estimate_initial_success', {
                  'event_category': 'estimate',
                  'event_label': 'initial_form',
                  'value': 1
                })
              }
            }
          })
          .catch((err) => {
            this.message = 'An error occurred please try again'
            // Send GA event
            if (this.$ga) {
              this.$gtag.event('estimate_form_error', {
                'event_category': 'error',
                'event_label': err.response.data.message,
                'value': 0
              })
            }
          })
      },
      processGraphicForm () {
        const recpatchaValue = document.getElementsByClassName('g-recaptcha-response')[0].value
        if (!recpatchaValue) {
          // Send GA event
          if (this.$ga) {
            this.$gtag.event('estimate_recaptcha_error', {
              'event_category': 'estimate',
              'event_label': 'recaptcha',
              'value': 0
            })
          }
          return
        }

        for (let elem of this.$refs.formGraphic.elements) {
          // Validate required fields
          if (elem.name && elem.required && !elem.value) {
            // Show validation warning on field
            this.$refs.formGraphic.reportValidity()
            return
          }

          // Quantity value check
          if (elem.name === 'mountingStyleQty' || elem.name === 'graphicPanelQty') {
            if (!Number.isInteger(parseInt(elem.value))) {
              elem.value = ''
              this.$refs.formGraphic.reportValidity()
              return
            }
          }
        }

        // Send GA event
        if (this.$ga) {
          this.$gtag.event('estimate_success', {
            'event_category': 'estimate',
            'event_label': 'success',
            'value': 3
          })
        }

        this.$refs.formGraphic.submit()

        for (let elem of this.$refs.formGraphic.elements) {
          elem.disabled = true
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../assets/css/contact.scss';

  .inputs {
    font-family: Helvetica Neue, Helvetica, Arial;
  }

  .display-image {
    width: 100px;
    height: 100px;
    padding-right: 5px;
    padding-bottom: 5px;
    cursor: pointer;
  }

  .flip-mobile {
    @media (max-width: 767.98px) {
      display: flex;
      flex-direction: column-reverse;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Estimate.vue